import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
  Cascader as Cascaded, Popover, Tooltip,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import {
  getRankingListAsync,
  selectTwoMenus,
  setRankingList,
  traceRoute,
} from '../../layouts/layoutSlice'
import {getRecipeCategoryName, isRecipePayable, Recipe, RecipeCategory} from '../../models/recipe'
import { OverOnlineLimitModal, getOverOnlineLimitList } from '../treatment/editor/modals/OverOnlineLimitModal'
import { ThemeContext } from '../../theme/ThemeContext'
import {
  RecipeEditor,
  RecipeEditorMode,
} from '../treatment/editor/RecipeEditor'
import styles from './Retail.module.css'
import { RetailList } from './RetailList'

import {
  getPatientInsuranceTradeCntAsync,
  getRecipeItems,
  getRecipeList,
  getSaveDiseaseAsync,
  selectCurrentTab,
  selectTreatmentId,
  setCurrentTab,
  setTreatmentId,
} from './retailSlice'
import { selectTenant,selectSettings } from '../../features/user/setting/settingSlice'
import {
  selectRecipeMaterials,
  resetRecipeEditor,
} from '../treatment/editor/recipeEditorSlice'
import { RegistrationCategory } from '../../models/registration'
import {
  selectCredentials,
  selectEdition,
  selectInsuranceArray,
  selectStationCategory,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantCountyCode,
  selectTenantId,
  selectTenantName,
  selectUserDepartmentId,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import { MedicelListValue } from '../../models/setting'
import {
  CloseCircleFilled,
  CloseOutlined,
  SearchOutlined,
  SettingOutlined,
  CaretDownFilled
} from '@ant-design/icons'
import {getTradeCode, readTypes, readTypesPlusFace} from '../../models/material'
import {
  medicalSendHttp,
  pingTargeHttp,
  readCardEHttp,
  readCardSHttp,
  strParse,
} from '../../utils/MedicalUtils'
import moment from 'moment'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import {
  getOutpatientDepartment,
  getPatientInfoAsync,
  searchQueryPsnAsync,
  selectDepartments,
  medicalRegisterAsync,
  selectFeeList,
  getFeeList,
  register,
  setAppointmentIdSlice,
  registerValue,
  getMedicalNum,
  getPatientDetail,
  getPatientList,
  selectPatients,
  getIsSeeDoctor,
  selectPatientDetail,
  setPatient,
  getInsurancePatientSpecialDiseaseByYbPersonalNoAsync,
  searchPsnSumAsync,
  medicalRegisterForMultiYidiAsync,
  setPatients,
  setRegistrationFeeList,
  getAddress,
} from '../registration/register/registerSlice'
import { selectInsuranceItem, setInsurance } from '../../layouts/insuranceSlice'
import { Gender, getGenderName } from '../../models/user'
import { DiseaseInput } from '../../compnents/input/DiseaseInput'
import { Disease } from '../../models/disease'
import {
  otherPatientInsuranceItemParams,
  PaymentRegistrationParams,
} from '../../models/payment'
import { reSetRegistration } from '../treatment/treatmentSlice'
import * as P from '../../models/patient'
import * as R from '../../models/registration'
import { Fee } from '../../models/fee'
import { serverType } from '../../services/commodity'
import {
  beforeAlertAsync,
  FeeListUpAsync,
  FeeListUpCancelAsync,
  MdtrtinfoUpAsync,
  preSettlementAsync,
  setUpdateFlagsAsync,
} from '../payment/confirm/paymentConfirmSlice'
import { RefreshFilled } from '../../compnents/icons/Icons'
import {
  getSelectSpecialDiseaseIcd10,
  getTreatment,
  getTreatments,
} from '../treatment/diagnosis/diagnosisSlice'
import {
  checkTreatmentAsync,
  finishWpWaitUploadAsync,
  getTreatmentNotice,
  selectTreatment,
  selectTreatmentUpdateFlgsAsync,
  setPatientInfo,
  setRecipeEditorTreatment,
  resetRecipeList,
} from '../treatment/editor/recipeListEditorSlice'
import { patientInfo } from '../../models/intelligence'
import { PatientModal } from '../patient/modals/PatientModal'
import { SearchMembersModal } from '../membersManagement/searchMembersModal'
import { AddMembersModal } from '../membersManagement/addMembersModal'
import { getAddMembers, getSearchMembersByPhone } from '../membersManagement/MembersManagementPageSlice'
import { useLocation } from 'react-router-dom'
import { selectIsAllZifeiAsync } from '../treatment/beautyClinic/beautyClinicSlice'
import {
  TreatmentCategoriesCQ,
  getTreatmentCategoryName,
  TreatmentCategories,
  TreatmentCategoriesJS,
  TreatmentCategoriesZF,
  TreatmentCategory,
  TreatmentNotice,
} from '../../models/treatment'
import { getYBTypeName } from '../../models/ybType'
import { GlobalKeyboardAction } from '../../compnents/actions/GlobalKeyboardAction'
import { RetailPreferencesSettingModal } from './retailPreferencesSettingModal'
import { getAge } from '../../utils/StringUtils'
import { DiagnosisAndPrescriptionModal } from './DiagnosisAndPrescriptionModal'
import { MedicationAdministrationRecordModal } from '../treatment/tcmCases/MedicationAdministrationRecordModal'
import { YBJRJSModal } from './YBJRJSModal'
import { getCounselor } from '../A-toothModule/toothHome/toothHomeSlice'
import { getCounselorListTimePage, getDoctorsInDepartmentTimeListAsync } from '../treatment/blindPersonmedical/blindPersonmedicalSlice'
import { getDoctorsInDepartmentListAsync } from '../completion/completionSlice'
import _ from 'lodash'
import { pinyin } from 'pinyin-pro'
import { Checks } from '../../models/personalSetting'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../models/dataPersion'
import { decrypt } from '../../models/m'
import { Checks as SettingChecks  } from '../../models/setting'
import {phonePattern} from "../../utils/RegExp";
import { getMaskPhone } from '../../models/phone'

let ghlb = ''  //挂号类别
let hzxb = 0 //患者性别
let xzcf = '' //默认选择处方

export const Retail = (): ReactElement => {
  const [isModalVisible, setIsModalVisible] = useState<any>()

  const [isYBJRJSModalVisible, setIsYBJRJSModalVisible] = useState<any>()

  const { Text } = Typography

  const [isAskMedicine, setIsAskMedicine] = useState(false)

  const [otherCountyCard, setOtherCountyCard] = useState(false)

  const settings = useSelector(selectSettings)

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '身份证格式错误',
    },
    {
      max: 18,
      message: '最长18位!',
    },
  ])
  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const { Option } = Select

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const twoMenus = useSelector(selectTwoMenus)

  const hisVersion = useSelector(selectEdition) //区分口腔版还是普通

  const currentTab = useSelector(selectCurrentTab)

  const treatmentId = useSelector(selectTreatmentId)

  const [category, setCategory] = useState(RecipeCategory.Medicine)

  const [tipsCount, setTipsCount] = useState<any>()

  const [cfsqjlFlag, setcfsqjlFlag] = useState(false)

  const [recipes, setRecipes] = useState<Recipe[]>([])

  // 超出挂网价提醒弹窗
  const [isOverOnlineModalVisible, setIsOverOnlineModalVisible] =
    useState(false)
  // 弹窗展示的挂网价异常明细（预结算前实时拉取，本地 recipes 可能不是最新的）
  const [overOnlineLimitList, setOverOnlineLimitList] = useState<any[]>([])
  // 点「仍要继续」时继续执行原按钮的逻辑
  const overOnlineContinueRef = useRef<(() => void) | null>(null)

  // 校验挂网价异常：按处方 id 拉最新明细，有异常先弹提醒，点「仍要继续」再继续原逻辑
  const checkOverOnlineLimit = (continueFn: () => void) => {
    const payableRecipes = recipes.filter(isRecipePayable)
    if (!payableRecipes.length) {
      continueFn()
      return
    }
    Promise.all(
      payableRecipes.map((r: any) =>
        dispatch(getRecipeItems(r.id))
          .then(unwrapResult)
          .catch(() => [])
      )
    ).then((lists: any[]) => {
      const list = getOverOnlineLimitList(lists.flat())
      if (list.length) {
        overOnlineContinueRef.current = continueFn
        setOverOnlineLimitList(list)
        setIsOverOnlineModalVisible(true)
      } else {
        continueFn()
      }
    })
  }

  const handleOverOnlineContinue = () => {
    setIsOverOnlineModalVisible(false)
    const continueFn = overOnlineContinueRef.current
    continueFn && continueFn()
  }

  const materials = useSelector(selectRecipeMaterials)

  const JuheShow: any = useSelector(selectTenant) //是否显示聚合支付按钮

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [messageFlag, setMessageFlag] = useState<any>(false)

  const [value, setValue] = useState(0)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [isHisCode, setIsHisCode] = useState(false)

  const [diabled, setDiabled] = useState<any>(false)

  const [hasCard, setHasCard] = useState(false)

  const [ageUnit, setAgeUnit] = useState<'year' | 'month'>('year')

  const readCardRef = useRef<any>(null)

  const [readLoading, setReadLoading] = useState(false)

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const tenantId = useSelector(selectTenantId)

  const [loading, setLoading] = useState(false)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const [fullCardInfo, setFullCardInfo] = useState<string>()
  const [qrCode, setQrCode] = useState<string>()
  const [chnlId, setChnlid] = useState<string>()

  const baseData = useSelector(selectInsuranceItem)
  const [patientInsurance, setPatientInsurance] = useState<any>()

  const cycleCode = sessionStorage.getItem('cycleCode')

  const tenantCountyCode = useSelector(selectTenantCountyCode)

  const tenantCategory = useSelector(selectTenantCategory)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantName = useSelector(selectTenantName)

  const [parintInfo, setParintInfo] = useState<any>({})

  const [tradeCntInfo, setTradeCntInfo] = useState<any>({})

  const departments = useSelector(selectDepartments)

  const patients = useSelector(selectPatients)

  const patient: any = useSelector(selectPatientDetail)

  // const doctors = useSelector(selectDoctors)

  const [treatmentAssistantDoctorList, setTreatmentAssistantDoctorList] = useState<any[]>() //  助理医师数据

  const [isDiseaseEmpty, setIsDiseaseEmpty] = useState(false)

  const [doctors, setDoctors] = useState<any[]>()
  
  const [treatmentNum, setReatmentNum] = useState<any>()

  const [selectedDiseases, setSelectedDiseases] = useState<Disease[]>([])

  const [selectedDiseasesZIFEI, setSelectedDiseasesZIFEI] = useState<Disease[]>(
    []
  )

  const [currenttreatmentId, setcurrenttreatmentId] = useState(0)

  const patientAutoFilled = useRef(false) // 患者是否由会员卡自动回填

  const [isPatientOverlayVisible, setIsPatientOverlayVisible] = useState(false)

  const [patientId, setPatientId] = useState('')

  const [disable, setDisable] = useState(false)

  const [appointmentId, setAppointmentId] = useState('')

  const departmentId = useSelector(selectUserDepartmentId)

  const storeuserId = userId

  const [flag, setFlag] = useState(false) //是否手动选择医生

  const [isInsurance, setIsInsurance] = useState(false)

  const [ybJiuzhenid, setYbJiuzhenid] = useState('')

  const fees = useSelector(selectFeeList)

  const [registrationId, setregistrationId] = useState('')

  const [
    otherPatientInsuranceItem,
    setOtherPatientInsuranceItem,
  ] = useState<otherPatientInsuranceItemParams>({})

  const [patientData, setpatientData] = useState<patientInfo | undefined>(
    undefined
  )

  const [btnLoading, setBtnLoading] = useState(false) //保存患者按钮 looding

  const [patientObj, setPatientObj] = useState<any>() //完善病历信息弹窗

  const [localObj, setLocalObj] = useState<any>() //本地存储

  const [patientBtn, setPatientBtn] = useState(false) //完善病历信息弹窗按钮

  const [searchPsnSumDisabled, setSearchPsnSumDisabled] = useState<boolean>(
    false
  )
  const [patientModalVisible, setPatientModalVisible] = useState(false) //完善病历信息弹窗

  const [searchMembersBtnText, setSearchMembersBtnText] = useState(0) //会员卡文字状态

  const [membersInfo, setMembersInfo] = useState<any>() // 会员卡信息
  const isShow: any = useSelector(selectSettings)[29] //判断是否开通智能审方

  const [tipsVisible, setIsTipsVisible] = useState<any>(false)
  const [recipesMemo, setRecipesMemo] = useState<any[]>([])
  const [isAnimating, setIsAnimating] = useState(false)
  const [showMemoStruct, setShowMemoStruct] = useState<any>({}) //显示出来的医保备注信息（取结构体的最后一条）

  const [searchMembersModalVisible, setSearchMembersModalVisible] = useState(
    false
  ) //搜索会员弹窗

  const [
    isRetailPreferencesSettingVisible,
    setIsRetailPreferencesSettingVisible,
  ] = useState(false)

  const [addMembersVisible, setAddMembersVisible] = useState(false) // 新增会员弹窗

  const [addBtnType, setAddBtnType] = useState(false) // 新增会员弹窗

  const [searchMedicalList, setSearchMedicalList] = useState<any>()

  const [notice, setNotice] = useState<TreatmentNotice | undefined>()

  const [keyword, setKeyword] = useState('')

  const [phoneDisabled, setPhoneDisabled] = useState(false)

  const [sumVisible, setSumVisible] = useState(false)

  const [sumList, setSumList] = useState<any>()

  const [pingState, setPingState] = useState(false)
  const credentials = useSelector(selectCredentials)
  const treatment = useSelector(selectTreatment)

  const stationCategory = useSelector(selectStationCategory)

  const [currentPatientId, setCurrentPatientId] = useState<any>()

  const [isTipsModalVisible, setIsTipsModalVisible] = useState<any>()

  const [inputValues, setInputValues] = useState<Record<string, string>>({})

  const [inputIcds, setInputIcds] = useState<Record<string, string>>({})

  const [diseaseOptions, setDiseaseOptions] = useState<any>()

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [isShowBeforeAlert, setIsShowBeforeAlert] = useState(false)

  const [isAutoRemind, setIsAutoRemind] = useState(false)

  const [beforeAlertMessage, setBeforeAlertMessage] = useState('')

  const [hasBeenAlerted, setHasBeenAlerted] = useState(false)

  const [
    isMedicationAdministrationRecordVisible,
    setIsMedicationAdministrationRecordVisible,
  ] = useState(false)

  const [KSKDCKHRSJHData, setKSKDCKHRSJHData] = useState(true) // 快速开单查看患者手机号权限

  const obj = JSON.parse(localStorage.getItem('localObj') || '{}')

    //0.取最新的偏好设置内容
  const localData: any = JSON.parse(
    localStorage.getItem('retailPreferencesSettingData') || '{}'
  )

  const editMedicalVisible = localStorage.getItem('editMedicalVisible')

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const formGutter = 20

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 4.75rem',
      textAlign: 'right',
    },
  }

  const thirdColumnLayout = {
    labelCol: {
      flex: '0 0 3rem',
    },
  }

  const menuList = twoMenus?.filter((v) => {
    return v?.name == '快速开单'
  })?.[0]

  const getKeys = (i: string) => {
    switch (i) {
      case '快速开单':
        return '0'
      case '收费明细':
        return '1'
      default:
        return '-'
    }
  }

  useEffect(() => {
    localStorage?.removeItem('groupNumber')
  }, [])

  useEffect(() => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KSKDCKHRSJH }))
      .then(unwrapResult)
      .then((res: any) => {
        setKSKDCKHRSJHData(res)
      })
  }, [])

  useEffect(() => {
    getTreatmentAssistantDoctorFn()
  }, [])

  useEffect(() => {
    //获取省市数据
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllList(res)
      })
  }, [])

  useEffect(() => {
    if (
      patientInsurance &&
      patientInsurance.insuranceCode &&
      patientInsurance.insuranceCode !== 'ZIFEI'
    ) {
      getPingState()
    }
  }, [patientInsurance])

  const getPingState = () => {
    pingTargeHttp((call: any) => {
      setPingState(call)
    })
  }
  useEffect(() => {
    if ((!cfsqjlFlag && departments.length && departmentId) || !isHisCode) {
      const targetDept = departments.find((d) => d.id == departmentId)
      if (targetDept) {
        form.setFieldsValue({
          ZIFEIregistrationDepartmentId: stationCategory != 0 ? departmentId : '',
          registrationDepartmentId: departmentId,
          area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
        })
        setDoctors([])
        getDoctorList(departmentId, credentials?.isAskMedicine)
        const objs = {
          ...localObj,
        treatmentDepartmentId: departmentId,
        treatmentDepartmentName: departments?.filter(
          (v: any) => v.id == departmentId
        )[0]?.name,
          patientSex: form.getFieldValue('sex') || hzxb || 0,
        }
        setLocalObj(objs)
        setPatientObj({ ...patientObj, ...objs })
        localStorage.setItem('localObj', JSON.stringify(objs))
      }
    }
  }, [departments, departmentId, isHisCode])

  const getDoctorData = async (id: string) => {
    await getDoctorList(id,credentials?.isAskMedicine)
  }

  // 事前提醒
  const beforeAlert = async (serverType: serverType, responseString?: string, isAutoRemindFlag?: boolean) => {

    setHasBeenAlerted(true)
    if (!treatment || !treatment.id) {
      return
    }

    if (isAutoRemindFlag) {
      //验证本地是否开启前置机，检查本地9955端口是否开启
      try {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 1000)
        await fetch('http://127.0.0.1:9955', {
          method: 'POST',
          mode: 'no-cors',
          signal: controller.signal,
        })
        clearTimeout(timeoutId)
      } catch {
        setIsAutoRemind(false)
        setIsShowBeforeAlert(false)
        gotoPayment()
        return
      }
    }
    
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )
    setBeforeAlertMessage('正在查询医保事前提醒信息...')

    dispatch(
      beforeAlertAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem?.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          treatmentId: treatment?.id,
          patientId: treatment?.patientId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          //长兴走特殊的事前提醒
          if (tenantAreaCd == '330522') {
            const data = strParse(res)
            medicalSendHttp(
              {
                trade_args: [
                  'CX_SQTX',
                  data,
                  null,
                  insuranceItem.countryHospitalNb,
                  insuranceItem.secretToken,
                ],
              },
              (call, err) => {
                if (!err) {
                  if ('200' == call?.netmessage?.code) {
                    const alertList = call?.netmessage.data
                    let message = ''
                    for (let i = 0; i < alertList.length; i++) {
                      const d = alertList[i]
                      message +=
                        i +
                        1 +
                        "：<span style='font-weight: bold'>智能审核触发：" +
                        (d?.prompt_type == 1
                          ? "<span style='color:green'>提示</span>"
                          : d?.prompt_type == 2
                            ? "<span style='color:#8d1f06'>禁止</span>"
                            : d?.prompt_type == 3
                              ? "<span style='color:#b2056e;'>警告</span>"
                              : '其他提醒') +
                        '</span></br>'
                      message += d?.prompt_message + '</br>'
                      if (d?.prompt_type == 2) {
                        setHasBeenAlerted(false)
                      }
                    }
                    if (message) {
                      setBeforeAlertMessage(message)
                    } else {
                      setBeforeAlertMessage(
                        "<span style='font-weight:bold;color:green'>事前提醒校验通过，当前无预警信息。</span>"
                      )
                    }
                  } else {
                    setBeforeAlertMessage(
                      '查询事前提醒失败。' + call?.netmessage?.err_msg
                    )
                  }
                } else {
                  setBeforeAlertMessage(
                    '查询事前提醒失败。' + call?.netmessage?.err_msg
                  )
                }
              }
            )
          } else {
            const data = strParse(res)
            medicalSendHttp(
              {
                trade_args: [
                  data.infno,
                  data.url,
                  data,
                  insuranceItem.countryHospitalNb,
                  insuranceItem.secretToken,
                ],
              },
              (call, err) => {
                if (!err) {
                  beforeAlert('response', JSON.stringify(call.netmessage), isAutoRemindFlag)
                } else {

                  if (isAutoRemindFlag) {
                    setIsAutoRemind(false)
                    setIsShowBeforeAlert(false)
                    gotoPayment()
                  } else {
                    setBeforeAlertMessage(
                      '查询事前提醒失败。' + call?.netmessage?.err_msg
                    )
                  }
                }
              }
            )
          }
        } else {

          if (res && res.length) {
            if (isAutoRemindFlag) {
              setIsShowBeforeAlert(true)
            }
            setBeforeAlertMessage(res)
          } else {
            if (isAutoRemindFlag) {
              setIsAutoRemind(false)
              setIsShowBeforeAlert(false)
              gotoPayment()
            } else {
              setBeforeAlertMessage('当前病历暂无事前提醒')
            }
          }
        }
      })
      .catch((e: any) => {
        if (isAutoRemindFlag) {
          setIsAutoRemind(false)
          setIsShowBeforeAlert(false)
          gotoPayment()
        } else {
          setBeforeAlertMessage('查询事前提醒失败：' + e?.message)
        }
      })
  }

  const getDoctorList = (departmentId: string, isAskMedicine?: any) => {
      dispatch(getDoctorsInDepartmentListAsync({departmentId: departmentId, isAskMedicine: isAskMedicine}))
        .then(unwrapResult)
        .then((v: any) => {
          dispatch(getDoctorsInDepartmentTimeListAsync())
          .then(unwrapResult)
          .then((val) => {
            const list = v.records?.map((u:any) =>{
              return {
                ...u,
                id: u?.id?.toString() || '',
                name: u?.realname,
                gender: u?.sex,
              }
            })
            const doctorList = list
              ?.map((n: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == n.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...n,
                  lastRegTime:tenantCategory == 16 ? (time && time <= 120 ? time : '') :'',
                }
              })
            // 按 lastRegTime 分钟数升序排序
            const hasLastRegTime = doctorList.filter((item: any) => item.lastRegTime).sort((a:any, b:any) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime 
            })
            const notHasLastRegTime = doctorList.filter((item: any) => !item.lastRegTime)?.map((e: any) => ({
              ...e,
              namePY: pinyin(e.realname, {
                pattern: 'first',
                toneType: 'none',
                separator: '',
              }).toUpperCase()
            }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            setDoctors([...notHasLastRegTime, ...hasLastRegTime])
          })
        })
  }

  useEffect(() => {
    // 口腔版医生回填
    if (doctors && doctors?.length === 1) {
      form.setFieldsValue({
        registrationDoctorId: doctors[0].id,
      })
      const obj = {
        ...localObj,
        treatmentDoctorId: doctors[0].id,
        treatmentDoctorName: doctors[0].name,
      }
      setLocalObj(obj)
      setPatientObj({ ...patientObj, ...obj })
      localStorage.setItem('localObj', JSON.stringify(obj))
    } else {
      if (doctors?.find((u) => u.id === storeuserId) && !disable) {
        form.setFieldsValue({ registrationDoctorId: storeuserId })
        const doctor = doctors.find((u) => u.id === storeuserId)
        const obj = {
          ...localObj,
          treatmentDoctorId: storeuserId,
          treatmentDoctorName: doctor?.name,
        }
        setLocalObj(obj)
        setPatientObj({ ...patientObj, ...obj })
        localStorage.setItem('localObj', JSON.stringify(obj))
      }
    }
  }, [doctors, doctors?.length])

  useEffect(() => {
    setFlag(false)
  }, [])

  const isDoctor = doctors?.find((u) => u.id === storeuserId)
  useEffect(() => {
    if (!flag) {
      const ZIFEIregistrationDoctorId = form.getFieldValue('ZIFEIregistrationDoctorId')
      setTimeout(() => {
        if (isDoctor) {
        const selectedDoctorId =
          ZIFEIregistrationDoctorId ||
          form.getFieldValue('registrationDoctorId') ||
          (stationCategory != 0 ? storeuserId : undefined)
        const selectedDoctor = doctors?.find(
          (v: any) => v.id == selectedDoctorId
        )
        const objs = {
          ...localObj,
          treatmentDoctorId: selectedDoctorId,
          treatmentDoctorName: selectedDoctor?.name,
        }
         form.setFieldsValue({
          ZIFEIregistrationDoctorId:
            stationCategory != 0 ? storeuserId : undefined,
        })
        setLocalObj(objs)
        setPatientObj({ ...patientObj, ...objs })
        localStorage.setItem('localObj', JSON.stringify(objs))
      }
      }, 200);
    }
  }, [doctors, flag, storeuserId, isDoctor])

  useEffect(() => {
    getTreatmentAssistantDoctorFn()
  }, [])

  // 获取助理医师
  const getTreatmentAssistantDoctorFn = () => {
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 8,
      })
    )
      .then(unwrapResult)
      .then(({ records }) => {
       dispatch(getCounselorListTimePage())
          .then(unwrapResult).then((val) => {
            const list = records
              .filter((v: any) => v.kssxbz != 1)
              .filter((v: any) => v.state == 1)
            // 根据返回的list中的id匹配，把第二个接口返回的time字段合并进去
            const enrichedList = list
              ?.map((v: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == v.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...v,
                  lastRegTime: time && time <= 120 ? time : '',
                }
              })
            // 按 lastRegTime 分钟数升序排序，null/空 视为最大排最后
            const hasLastRegTime = enrichedList?.filter((item: any) => item.lastRegTime).sort((a: any, b: any) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime 
            })
            const notHasLastRegTime = enrichedList
              ?.filter((item: any) => !item.lastRegTime)
              ?.map((e: any) => ({
                ...e,
                namePY: pinyin(e.realname, {
                  pattern: 'first',
                  toneType: 'none',
                  separator: '',
                }).toUpperCase()
              }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            setTreatmentAssistantDoctorList([ ...notHasLastRegTime,...hasLastRegTime])
          })
      }
      )
  }

  useEffect(() => {
      // 获取快速开单偏好设置 2000 2001 2002 2003 2004
      const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')
      const res = allPersonalPreferences?.records || []
      const KSKDGHLX = res?.find((item: any) => item?.code == Checks.KSKDGHLX)?.codeName //挂号类别
      ghlb = KSKDGHLX ? KSKDGHLX : localData?.insuranceStatus ? localData?.insuranceStatus : 'ZIFEI'
      const KSKDHZXB = res?.find((item: any) => item?.code == Checks.KSKDHZXB)?.codeName //患者性别
      hzxb = KSKDHZXB?.toString ? Number(KSKDHZXB) : localData?.sex ? Number(localData?.sex) : 0
      const KSKDXZCF = res?.find((item: any) => item?.code == Checks.KSKDXZCF)?.codeName //默认选择处方
      xzcf = KSKDXZCF?.toString() ? KSKDXZCF?.toString() : localData?.recipeType?.toString() ? localData?.recipeType?.toString() : '0'
      if (!treatmentId) {
        useSetting('all')
      }
  }, [])


  const getMRTN = (patientId: any)=>{
      dispatch(getPatientInsuranceTradeCntAsync(patientId))
      .then(unwrapResult)
      .then((v:any) => {
        Modal.warning({
          width: 550,
          bodyStyle: {
            width: '550px',
          },
          content: v,
          onOk: () => {
            return
          },
          onCancel: () => {
            return
          },
        })
      })
  }
  
  useEffect(() => {
    if (materials?.length && isShow) {
      const arr = materials
        ?.filter((v: any) => {
          return v?.memo && v?.memo != '' && v?.memo?.length > 5
        })
        ?.map((v: any) => {
          return {
            name: v?.name,
            memo: v?.memo,
          }
        })
      const recipeData: any = recipes?.find((v) => v?.id == recipes.find((r) => r.category === category)?.id)
      if (recipeData?.prescriptionReminders) {
        treatment?.allergen &&
        treatment?.allergen != '无过敏史' &&
        treatment?.allergen != '否认药物食物过敏史' &&
        treatment?.allergen != '否认药物过敏史' &&
        treatment?.allergen != '否认食物过敏史' &&
        treatment?.allergen != '无'
          ? setRecipesMemo([
            { name: '过敏史', memo: treatment?.allergen },
            ...arr,
            {
              name: getRecipeCategoryName(recipeData?.category),
              memo: recipeData?.prescriptionReminders,
            },
          ])
          : setRecipesMemo([
            ...arr,
            {
              name: getRecipeCategoryName(recipeData?.category),
              memo: recipeData?.prescriptionReminders,
            },
          ])
      } else {
        treatment?.allergen &&
        treatment?.allergen != '无过敏史' &&
        treatment?.allergen != '否认药物食物过敏史' &&
        treatment?.allergen != '否认药物过敏史' &&
        treatment?.allergen != '否认食物过敏史' &&
        treatment?.allergen != '无'
          ? setRecipesMemo([
            { name: '过敏史', memo: treatment?.allergen },
            ...arr,
          ])
          : setRecipesMemo(arr)
      }
    } else {
      setRecipesMemo(
        treatment?.allergen &&
        treatment?.allergen != '无过敏史' &&
        treatment?.allergen != '否认药物食物过敏史' &&
        treatment?.allergen != '否认药物过敏史' &&
        treatment?.allergen != '否认食物过敏史' &&
        treatment?.allergen != '无'
          ? [{ name: '过敏史', memo: treatment?.allergen }]
          : []
      )
    }
  }, [materials, isShow, recipes])

  useEffect(() => {
    // 自费信息回显
    if (JSON.stringify(obj) != '{}' && cfsqjlFlag) {
      if (!obj.state && materials?.length == 0 && !isHisCode && !form.getFieldValue('name')) {
        setKeyword('')
        setDisable(false)
        setAgeUnit('year')
        form.setFieldsValue({
          name: undefined,
          ageMonth: undefined,
          ageYear: undefined,
          ageDay: undefined,
          birthday: undefined,
          patientId: undefined,
          patientName: undefined,
          sex: 0,
          phone: undefined,
          treatmentNo: undefined,
          state: undefined,
          area: undefined,
          provinceCode: undefined,
          cityCode: undefined,
          contryCode: undefined,
          address:undefined,
          ZIFEIregistrationDepartmentId: obj?.treatmentDepartmentId || '',
          ZIFEIregistrationDoctorId: obj?.treatmentDoctorId || '',
        })

        const objs = {
          ...localObj,
          patientName: undefined,
          name: undefined,
          ageYear: undefined,
          ageMonth: undefined,
          ageDay: undefined,
          birthday: undefined,
          patientSex: 0,
          patientId: undefined,
          phone: undefined,
          treatmentNo: undefined,
          state: undefined,
          area: undefined,
          provinceCode: undefined,
          cityCode: undefined,
          contryCode: undefined,
          address:undefined,
        }
        setLocalObj(objs)
        setPatientObj({ ...patientObj, ...objs })
        localStorage.setItem('localObj', JSON.stringify(objs))
        getDoctorData(obj.treatmentDepartmentId)
      }
    }
  }, [materials?.length,cfsqjlFlag])

  useEffect(() => {
    if (menuList?.subMenus?.length) {
      dispatch(
        setCurrentTab(currentTab || getKeys(menuList?.subMenus?.[0]?.name))
      )
    }
  }, [menuList?.subMenus])

  useEffect(() => {
    // recipesMemo变化时触发动画效果
    if (recipesMemo.length > 0) {
      if (
        showMemoStruct?.name ==
        recipesMemo.length + '. ' + recipesMemo[recipesMemo?.length - 1]?.name
      ) {
        return
      }
      const recipeData: any = recipes?.find((v) => v?.id == recipes.find((r) => r.category === category)?.id)
      setShowMemoStruct({
        name: recipeData?.prescriptionReminders
          ? getRecipeCategoryName(recipeData?.category)
          : recipesMemo.length +
          '. ' +
          recipesMemo[recipesMemo?.length - 1]?.name,
        memo: recipeData?.prescriptionReminders
          ? recipeData?.prescriptionReminders
          : recipesMemo[recipesMemo?.length - 1]?.memo,
      })
      setIsAnimating(true)

      // 在一段延迟后结束动画
      const timeout = setTimeout(() => {
        setIsAnimating(false)
      }, 1000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [recipesMemo])

  useEffect(() => {
    dispatch(setPatientInfo({}))
  }, [])

  useEffect(() => {
    setIsAskMedicine(credentials?.isAskMedicine == 1)
  }, [credentials])

  useEffect(() => {
    dispatch(setRecipeEditorTreatment({} as any))
  }, [])

  useEffect(() => {
    if (value != null && value == 0) {
      setIsInsurance(false)
    } else {
      setIsInsurance(true)
    }
  }, [value])

  useEffect(() => {
    dispatch(getFeeList(insuranceItem?.insuranceCode))
    getResiterMedicalNum()
  }, [insuranceItem])

  useEffect(() => {
    // 获取科室
     dispatch(getOutpatientDepartment(credentials?.isAskMedicine))
  }, [])

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

    const clearZifeiForm = () => {
        patientAutoFilled.current = false
        setMembersInfo({})
        setSearchMembersBtnText(0)
        setIsInsurance(false)
        setDisable(false)
        setIsHisCode(false)
        setAgeUnit('year')
        form.setFieldsValue({
          ageYear: '',
          ageMonth: '',
          ageDay: '',
          birthday: '',
          sex: 0,
          phone: '',
          name: '',
          treatmentNo: '',
          area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
          address: '',
        })
      const obj = {
        ...localObj,
        patientName: undefined,
        name: undefined,
        ageYear: undefined,
        ageMonth: undefined,
        ageDay: undefined,
        birthday: undefined,
        patientSex: 0,
        patientId: undefined,
        phone: undefined,
        treatmentNo: undefined,
        state: undefined,
        area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
        provinceCode: provinceCode,
        cityCode: cityCode,
        contryCode: countyCode,
        address: undefined,
      }
      setLocalObj(obj)
      setPatientObj({ ...patientObj, ...obj })
      localStorage.setItem('localObj', JSON.stringify(obj))
        setKeyword('')
        setSelectedDiseasesZIFEI([])
        dispatch(setTreatmentId(undefined))
        setRecipes([])
        setcurrenttreatmentId(0)
        setNotice(undefined)
        useSetting('noInsuranceCheck')
  }

  const clearYBForm = () => {
    patientAutoFilled.current = false
    setMembersInfo({})
    setSearchMembersBtnText(0)
    setIsInsurance(true)
    setHasCard(false)
    setIsHisCode(true)
    setDisable(false)
    setPatientInsurance({})
    setNotice(undefined)
    setParintInfo({})
    setSelectedDiseases([])
    setPhoneDisabled(false)
    setReatmentNum('')
    form.setFieldsValue({
      treatmentNo: '',
    })
    getResiterMedicalNum()
    setRecipes([])
    setcurrenttreatmentId(0)
  }

  const handleFullReset = () => {
    clearZifeiForm()
    setOtherCountyCard(false)
    setCategory(RecipeCategory.Medicine)
    setTipsCount(1)
    setRecipes([])
    setcurrenttreatmentId(0)
    dispatch(setTreatmentId(undefined))
    dispatch(resetRecipeEditor())
    setMessageFlag(false)
    setValue(0)
    setIsHisCode(false)
    setDiabled(false)
    setHasCard(false)
    setReadLoading(false)
    setFullCardInfo('')
    setPatientInsurance({})
    setQrCode('')
    setChnlid('')
    dispatch(setPatient(undefined))
    setIsDiseaseEmpty(false)
    setIsPatientOverlayVisible(false)
    setPatientId('')
    setDisable(false)
    setAppointmentId('')
    setFlag(false)
    setIsInsurance(false)
    setYbJiuzhenid('')
    setregistrationId('')
    dispatch(setRegistrationFeeList([]))
    setOtherPatientInsuranceItem({})
    setpatientData(undefined)
    setBtnLoading(false)
    setPatientObj(undefined)
    setLocalObj(undefined)
    setPatientBtn(false)
    setSearchPsnSumDisabled(false)
    setPatientModalVisible(false)
    setSearchMembersBtnText(0)
    setMembersInfo(undefined)
    setIsTipsVisible(false)
    setSearchMembersModalVisible(false)
    setIsRetailPreferencesSettingVisible(false)
    setAddMembersVisible(false)
    setAddBtnType(false)
    setSearchMedicalList(undefined)
    setNotice(undefined)
    setKeyword('')
    setSumVisible(false)
    setSumList(undefined)
    setPingState(false)
    dispatch(resetRecipeList())
    setCurrentPatientId(undefined)
    setParintInfo({})
    setTradeCntInfo({})
    getResiterMedicalNum()
    setAgeUnit('year')
    form.setFieldsValue({
      registrationCategory: 0,
      ageYear: '',
      ageMonth: '',
      ageDay: '',
      birthday: '',
      sex: 0,
      phone: '',
      name: '',
      address: '',
      area: [],
      treatmentNo: '',
      treatmentCategory: TreatmentCategory.Normal,
      disease: '',
    })
    setKeyword('')
    setDiabled(false)
    setSelectedDiseasesZIFEI([])
    cancelInsurance()
    useSetting('noInsuranceCheck')
    setSelectedDiseases([])
    setSelectedDiseasesZIFEI([])
  }

  const provinceCode = credentials?.tenantProvinceCode
    ? Number(credentials?.tenantProvinceCode + '000000')
    : ''
  const cityCode = credentials?.tenantCityCode
    ? Number(credentials?.tenantCityCode + '000000')
    : ''
  const countyCode = credentials?.tenantCountyCode
    ? Number(credentials?.tenantCountyCode + '000000')
    : ''

  useEffect(() => {
    form.setFieldsValue({
      area: provinceCode ? [provinceCode, cityCode, countyCode] : [],
    })
  }, [])
  
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    } else {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  useEffect(() => {
    if (treatmentId) {
      dispatch(getRecipeList(treatmentId))
        .then(unwrapResult)
        .then((recipes) => {
          const recipeList: any = recipes?.map((v) => {
            return {
              ...v,
              category: v?.category == RecipeCategory.Treatment ? RecipeCategory.Medicine : v?.category
            }
          })
          setRecipes(recipeList)

        })
      dispatch(setTreatmentId(undefined))
    }
  }, [treatmentId])

  // 自费
  const submit = (recipes: Recipe[]) => {
      if (String(credentials?.tenantCityCode) === '320500' && form.getFieldValue('registrationCategory') == RegistrationCategory.SelfPay) {
      if ((!selectedDiseasesZIFEI || selectedDiseasesZIFEI.length === 0)) {
        notification.warning({
          message: '必填项未填写',
          description: '诊断为必填项，请先填写诊断',
          placement: 'topRight'
        })
        return
      }
    }
    const rs = recipes.filter(isRecipePayable)
    if (rs.length > 0) {
      dispatch(
        traceRoute({
          name: '快速开单',
          path: '/payment/confirm',
          query: `ids=${rs.map((r) => r.id).join(',')}&phone=${
            membersInfo?.memberPhone || patientObj?.phone
          }`,
          state: {
            where: ['收费明细', '结算明细'],
            backtrace: {
              name: '快速开单',
              path: '/retail',
              query: `treatmentId=${rs[0].treatmentId}`,
            },
            settlementCategory: 'retail', // 收费页面判断是否为药品零售的单子
          },
        })
      )
    }
  }

  // 医保
  const linkToPayment = (str?: any) => {
    const rs = recipes.filter(isRecipePayable)
    if (rs.length > 0) {
      dispatch(
        traceRoute({
          name: '快速开单',
          path: '/payment/confirm',
          query: `ids=${rs.map((r) => r.id).join(',')}&phone=${membersInfo?.memberPhone || patientObj?.phone}`,
          state: {
            where: ['收费明细', '结算明细'],
            prePay: str,
            routerLink: true,
            treatment,
            backtrace: {
              name: '快速开单',
              path: '/retail',
              // query: `treatmentId=${treatment?.id}`,
            },
          },
        })
      )
    }
  }

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (process.env.node_env === 'development') {
        console.warn('Global key handler installed.')
      }
      if (e.isComposing || e.code !== 'Space') {
        return
      }
      //submit(recipes);
    }
    if (currentTab === '0') {
      document.addEventListener('keydown', onKeyDown)
    } else {
      document.removeEventListener('keydown', onKeyDown)
    }
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [currentTab, recipes])

  const success = (str: string) => {
    setReadLoading(true)
    const hide = message.loading(str, 0)
    setTimeout(() => {
      hide()
      setReadLoading(false)
    }, 3000)
  }

  const successMessage = (str: string) => {
    setHasCard(true)
    notification.success({
      message: str,
    })
  }

  const readCard = () => {
    readCardRef.current.blur() //按钮失焦，防止重复点击
    const readType = form.getFieldsValue().readType

    success('读卡中')
    if (readType === 1) {
      readEType()
    } else if (readType === 2) {
      // const idCardNumber = form.getFieldsValue().idCardNumber
      // if (idCardNumber) {
      //   getPatientInfo(idCardNumber, 'requestString')
      // } else {
      //   notification.info({
      //     message: '请输入身份证号',
      //   })
      // }
    } else if (readType === 3) {
      readSType()
    } else if (readType === 11){
      readFaceType();
    }
  }

  useEffect(() => {
    getResiterMedicalNum()
    let timer: any = null
    timer = setInterval(() => {
      getResiterMedicalNum()
    }, 5000)
    return () => {
      timer && clearInterval(timer)
    }
  }, [dispatch])

  // 获取门诊号
  const getResiterMedicalNum = () => {
    dispatch(getMedicalNum())
      .then(unwrapResult)
      .then((res) => {
        setReatmentNum(res)
      })
  }

  // 人脸识别读卡
  const readFaceType = () => {
    readCardEHttp(
      {
        trade_args: [
          insuranceItem.countryHospitalNb,
          '01301',
          'cn.nhsa.ec.auth',
          userId,
          userName,
          '',
          '',
        ],
      },
      (data, err) => {
        if (!err) {
          const infoList = data.netmessage.split('|')
          getIdCardInfo(infoList[1])
          form.setFieldsValue({
            idCardNumber: infoList[1],
            ybkh: infoList[1],
          })
          getPatientInfo(
            data.netmessage,
            data?.QrCode,
            data?.ChnlId,
            'requestString'
          )
        } else {
          setLoading(false)
          setReadLoading(false)
        }
      }
    )
  }

  // 电子凭证读卡
  const readEType = () => {
    readCardEHttp(
      {
        trade_args: [
          insuranceItem.countryHospitalNb,
          '01301',
          '',
          userId,
          userName,
          '',
          '',
        ],
      },
      (data, err) => {
        if (!err) {
          const infoList = data.netmessage.split('|')
          getIdCardInfo(infoList[1])
          form.setFieldsValue({
            idCardNumber: infoList[1],
            ybkh: infoList[1],
          })
          getPatientInfo(
            data.netmessage,
            data?.QrCode,
            data?.ChnlId,
            'requestString'
          )
        } else {
          setLoading(false)
          setReadLoading(false)
        }
      }
    )
  }

  // 实体卡读卡
  const readSType = () => {
    readCardSHttp(
      {
        trade_args: [getTradeCode(tenantAreaCd.slice(0, 4))],
      },
      (data, err) => {
        if (!err) {
          getPatientInfo(
            baseData?.insuranceCode == 'JIANGSU'
              ? data.netmessage
              : JSON.stringify(data.netmessage),
            '0',
            '0',
            'requestString'
          )
          form.setFieldsValue({
            ybkh: data?.netmessage.CardNum,
            name: data?.netmessage.Name,
            idCardNumber: data?.netmessage.IDNum,
          })
          // getIdCardInfo(data?.netmessage.IDNum)
        } else {
          setLoading(false)
          setReadLoading(false)
        }
      }
    )
  }

  // 获取参保人信息
  const getPatientInfo = (
    fullCardInfo: string,
    qrcode: string,
    chnlid: string,
    serverType: any,
    responseString?: string
  ) => {
    const cardType = form.getFieldsValue().readType
    setFullCardInfo(fullCardInfo)
    setQrCode(qrcode)
    setChnlid(chnlid)
    dispatch(
      getPatientInfoAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          cardType: String(cardType) == '11' ? 1 : cardType,
          fullCardInfo,
          otherMap: {},
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call: any, err) => {
              if (!err) {
                success('正在获取人员信息')
                getPatientInfo(
                  fullCardInfo,
                  qrcode,
                  chnlid,
                  'response',
                  JSON.stringify(call.netmessage)
                )
              } else {
                setReadLoading(false)
              }
            }
          )
        } else {
          successMessage('读卡成功')
          setReadLoading(false)
          setPatientInsurance(res?.patientInsurance)
          if (
            res?.patientInsurance.patientId &&
            res?.patientInsurance.patientId != -1
          ) {
            getNotice(res?.patientInsurance.patientId)
          }
          // searchMedical(res?.patientInsurance, treatmentNum, 'requestString')
          searchMedical(res?.patientInsurance, 'requestString') //查询特慢病信息
          setTradeCntInfo(res?.cntBean);//保存结算次数信息
          setParintInfo({
            ...res.patientInsurance,
            age: calculateAge(res?.patientInsurance.birthday),
            name: res?.patientInsurance.name,
            address: res?.patientInsurance.address || res?.patientInsurance.brdw,
            provinceCode: res?.patientInsurance?.provinceCode && res?.patientInsurance?.provinceCode !=0 ? res?.patientInsurance?.provinceCode : provinceCode,
            cityCode: res?.patientInsurance?.cityCode && res?.patientInsurance?.cityCode !=0 ? res?.patientInsurance?.cityCode : cityCode,
            contryCode: res?.patientInsurance?.contryCode && res?.patientInsurance?.contryCode !=0 ? res?.patientInsurance?.contryCode : countyCode,
            idCardNumber: res?.patientInsurance.idCard,
            cbxzmc: res?.patientInsurance.cbxzmc, //险种类别
            memberTypemc: res?.patientInsurance.memberTypemc, // 人员类别
            treatmentStatusmc: res?.patientInsurance.treatmentStatusmc, //参保状态
            dnzhye: res?.patientInsurance.dnzhye, //当年余额
            lnzhye: res?.patientInsurance.lnzhye, // 历年余额
            sex: getGenderName(Number(res?.patientInsurance.sex)),
            ageYear: calculateAge(res?.patientInsurance.birthday),
          })
          getIdCardInfo(res?.patientInsurance.idCard)

          form.setFieldsValue({
            // ybkh: res?.patientInsurance.CardNum,
            name: res?.patientInsurance.name,
            phone: res?.patientInsurance.phone,
            address: res?.patientInsurance.address || res?.patientInsurance.brdw,
            area: res?.patientInsurance?.provinceCode && res?.patientInsurance?.provinceCode !=0
            ? [
              Number(res?.patientInsurance?.provinceCode),
              Number(res?.patientInsurance?.cityCode),
              Number(res?.patientInsurance?.contryCode),
            ] : [
              Number(provinceCode),
              Number(cityCode),
              Number(countyCode),
            ],
            idCardNumber: res?.patientInsurance.idCard,
            cbxzmc: res?.patientInsurance.cbxzmc,
            memberTypemc: res?.patientInsurance.memberTypemc,
            treatmentStatusmc: res?.patientInsurance.treatmentStatusmc,
            zhye: res?.patientInsurance.zhye,
            dnzhye: res?.patientInsurance.dnzhye,
            lnzhye: res?.patientInsurance.lnzhye,
            companyName: res?.patientInsurance.companyName,
            insuranceRegion: res?.patientInsurance.insuranceRegion,
            ybPersonalNo: res?.patientInsurance.ybPersonalNo,
            sex: Number(res?.patientInsurance.sex),
            ageYear: calculateAge(res?.patientInsurance.birthday),
          })

          // 医保盲人推拿科
          getMRTNKState(res?.patientInsurance)
        }
      })
      .catch(() => {
        setReadLoading(false)
      })
  }

  const getMRTNKState = (res?:any) => {
    const registrationDepartmentId = form.getFieldValue('registrationDepartmentId')
    const registrationDepartmentName = departments?.find((item) => item.id === registrationDepartmentId)?.name
    const registrationCategory = form.getFieldValue('registrationCategory') //费别
    if (registrationCategory != RegistrationCategory.SelfPay && registrationDepartmentName == '盲人推拿科') {
      if(res?.patientId && res?.patientId != -1){
        getMRTN(res?.patientId)
      }
    }
  }

  const calculateAge = (birthday: string) => {
    const today = new Date() // 获取当前时间
    const birthDate = new Date(birthday) // 将生日字符串转换为日期格式

    let age = today.getFullYear() - birthDate.getFullYear() // 根据年份计算年龄

    if (today < birthDate || today.getMonth() < birthDate.getMonth()) {
      age-- // 如果今天还没有到达生日月份或者已经超过了生日月份，则年龄需要减1
    } else if (
      today.getMonth() === birthDate.getMonth() &&
      today.getDay() < birthDate.getDay()
    ) {
      age-- // 如果今天已经到达了生日月份，但是还未到达生日日子，则年龄也需要减1
    }

    return age
  }

  // 2204 挂号的2204
  const FeeListUpR = (
    serverType: serverType,
    treatmentData: registerValue,
    values: Record<string, unknown>,
    responseString?: string
  ) => {
    dispatch(
      FeeListUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          registerFlag: 1,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('正在上传费用')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '费用上传',
            },
            (call, err) => {
              if (err) {
                setReadLoading(false)
              } else {
                FeeListUpR(
                  'response',
                  treatmentData,
                  values,
                  JSON.stringify(call.netmessage)
                )
              }
            },
            undefined
          )
        } else {
          preSettlementR('requestString', treatmentData, values)
        }
      })
  }

  // 2206 挂号的
  const preSettlementR = (
    serverType: serverType,
    treatmentData: registerValue,
    values: Record<string, unknown>,
    responseString?: string
  ) => {
    dispatch(
      preSettlementAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          chrg_bchno: '2',
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          patientId: String(treatmentData?.patientId),
          registrationId: String(treatmentData?.registrationId),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('正在挂号费预结算')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setReadLoading(false)
              } else {
                preSettlementR(
                  'response',
                  treatmentData,
                  values,
                  JSON.stringify(call.netmessage)
                )
              }
            }
          )
        }
      })
      .catch(() => {
        setReadLoading(false)
      })
  }

  // 获取患者特慢病信息
  const searchMedical = (
    res: any,
    serverType: any,
    responseString?: string
  ) => {
    dispatch(
      searchQueryPsnAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          insuplcAdmdvs: res?.insuranceRegion,
          psnNo: res?.ybPersonalNo,
          // 测试代码
          // insuplcAdmdvs: '330599',
          // psnNo: '33050099000010000000525114',
        },
      }) as any
    )
      .then(unwrapResult)
      .then(async (result: any) => {
        if (serverType === 'requestString') {
          const data = strParse(result)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              noSuccess: true,
            },
            (call: any) => {
              searchMedical(res, 'response', JSON.stringify(call.netmessage))
            }
          )
        } else {
          dispatch(
            getInsurancePatientSpecialDiseaseByYbPersonalNoAsync({
              ybPersonalNo: res?.ybPersonalNo,
            })
          )
            .then(unwrapResult)
            .then((v) => {
              setSearchMedicalList(v)
            })
        }
      })
  }

  useEffect(() => {
    if (isTipsModalVisible && searchMedicalList?.length) {
      const result = searchMedicalList.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = `${item.diagName?.split('/')?.[0]}`
        return obj
      }, {})
      const resultIcds = searchMedicalList.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = item.diagCode
        return obj
      }, {})
      setInputValues(result)
      setInputIcds(resultIcds)

      searchMedicalList?.map((v: any) => {
        form.setFieldsValue({
          [`diagnosis-${v.diseaseCode}`]: v?.diagName,
        })
      })
    }
  }, [isTipsModalVisible, searchMedicalList])

  const getDiseaseList = (diseaseCode: any, diseaseName?: any) => {
    dispatch(
      getSelectSpecialDiseaseIcd10({
        diseaseCode: diseaseCode,
        cbxz: patientInsurance?.cbxz,
        diseaseName: diseaseName,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDiseaseOptions({
          ...diseaseOptions,
          [diseaseCode]: v,
        })
      })
  }

  const mergeUniqueArrays = (baseArray: any, newArray: any) => {
    const icdsSet = new Set(baseArray.map((item: any) => item.icds))
    const uniqueItems = newArray.filter((item: any) => !icdsSet.has(item.icds))
    return [...baseArray, ...uniqueItems]
  }

  const handleOptionSelect = (icds: string, disName: any, disIcds?: any) => {
    setInputValues((prev) => ({
      ...prev,
      [icds]: disName,
    }))
    setInputIcds((prev) => ({
      ...prev,
      [icds]: disIcds,
    }))
  }

  const getIdCardInfo = (idCard: string) => {
    const date = new Date()

    const getMonth = date.getMonth() + 1 //当前月份
    const getDay = date.getDate() //当前日期
    const month = parseInt(idCard?.substr(10, 2)) //身份证上的月份
    const day = parseInt(idCard?.substr(12, 2)) //身份证上的日期

    const getFullYear = date.getFullYear() //当前年份
    const year = parseInt(idCard?.substr(6, 4)) //身份证上的年份

    const birthday = moment(idCard?.substr(6, 8)).format(DateTimeFormatSimple)
    let ageYear = 0

    //  身份证上的年月日
    if (idCard) {
      if (
        (idCard.length != 15 && idCard.length != 16 && idCard.length != 18) ||
        isNaN(Number(idCard.substr(0, 6)))
      ) {
        setOtherCountyCard(true)
        setIdCardRules([
          {
            max: 18,
            message: '最长18位!',
          },
        ])
      } else {
        setOtherCountyCard(false)
        setIdCardRules([
          {
            pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证格式错误',
          },
          {
            max: 18,
            message: '最长18位!',
          },
        ])
      }
      if (idCard.length === 18) {
        let ageMonth = 0
        if (getMonth - month > 0) {
          ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
          ageMonth = getMonth - month <= 0 ? 1 : getMonth - month
          if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
        } else if (getMonth - month < 0) {
          ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
          ageMonth = 12 - (month - getMonth) <= 0 ? 1 : 12 - (month - getMonth)
          if (getDay < day) ageMonth = Math.max(0, ageMonth - 1)
        } else if (getMonth - month === 0) {
          if (getDay < day) {
            ageYear = getFullYear - year - 1 < 0 ? 1 : getFullYear - year - 1
            ageMonth = 11
          } else {
            ageYear = getFullYear - year < 0 ? 1 : getFullYear - year
            ageMonth = 0
          }
        }
        const totalMonths = ageYear * 12 + ageMonth
        if (totalMonths < 12) {
          setAgeUnit('month')
          // 计算剩余天数
          let ageDayValue = moment().diff(moment(birthday).add(totalMonths, 'months'), 'days')
          if (ageDayValue < 0 && totalMonths > 0) {
            ageDayValue = moment().diff(moment(birthday).add(totalMonths - 1, 'months'), 'days')
            form.setFieldsValue({
              ageMonth: totalMonths - 1 <= 0 ? 1 : totalMonths - 1,
              ageDay: ageDayValue,
              birthday: birthday,
            })
          } else {
            form.setFieldsValue({
              ageMonth: totalMonths <= 0 ? 1 : totalMonths,
              ageDay: ageDayValue,
              birthday: birthday,
            })
          }
        } else {
          setAgeUnit('year')
          form.setFieldsValue({
            ageYear: ageYear < 0 ? 1 : ageYear,
            age: ageYear < 0 ? 1 : ageYear,
            ageMonth: ageMonth <= 0 ? 1 : ageMonth,
            birthday: birthday,
          })
        }
      } else if (idCard.length < 18 || idCard === '') {
        form.setFieldsValue({
          ageYear: '',
          age: '',
          ageMonth: '',
          ageDay: '',
          birthday: '',
        })
        ageYear = 0
      }
    }
    return ageYear
  }

  const updateBirthday = () => {
    if (ageUnit === 'year') {
      const year = parseInt(form.getFieldValue('ageYear')) || 0
      const month = parseInt(form.getFieldValue('ageMonth')) || 0
      if (year !== 0 || month !== 0) {
        const months = year * 12 + month
        const birthday = moment().subtract(months, 'months').format('YYYY/MM/DD')
        form.setFieldsValue({ birthday })
        const obj = {
          ...localObj,
          birthday: birthday,
        }

        setLocalObj(obj)
        setPatientObj({ ...patientObj, ...obj })
        localStorage.setItem('localObj', JSON.stringify(obj))
      }
    } else {
      const month = parseInt(form.getFieldValue('ageMonth')) || 0
      const day = parseInt(form.getFieldValue('ageDay')) || 0
      if (month !== 0 || day !== 0) {
        const birthday = moment().subtract(month, 'months').subtract(day, 'days').format('YYYY/MM/DD')
        form.setFieldsValue({ birthday })
        const obj = {
          ...localObj,
          birthday: birthday,
        }
        setLocalObj(obj)
        setPatientObj({ ...patientObj, ...obj })
        localStorage.setItem('localObj', JSON.stringify(obj))
      }
    }
  }

  const updateYearsAndMonths = () => {
    const date = moment(form.getFieldValue('birthday'))
    if (!date.isValid()) {
      return
    }
    if (date.isAfter(moment(), 'day')) {
      return
    }
    const totalMonths = moment().diff(date, 'months')
    if (totalMonths >= 12) {
      const year = Math.floor(totalMonths / 12)
      const month = totalMonths % 12
      setAgeUnit('year')
      form.setFieldsValue({
        ageYear: year,
        age: year,
        ageMonth: month,
      })
      const obj = {
        ...localObj,
        ageYear: year,
        ageMonth: month,
        ageDay: 0,
      }
      setLocalObj(obj)
      setPatientObj({ ...patientObj, ...obj })
      localStorage.setItem('localObj', JSON.stringify(obj))
    } else {
      const days = moment().diff(date.clone().add(totalMonths, 'months'), 'days')
      setAgeUnit('month')
      form.setFieldsValue({
        ageMonth: totalMonths,
        ageDay: days,
      })
      const obj = {
        ...localObj,
        ageYear: 0,
        ageMonth: totalMonths,
        ageDay: days,
      }
      setLocalObj(obj)
      setPatientObj({ ...patientObj, ...obj })
      localStorage.setItem('localObj', JSON.stringify(obj))
    }
  }

  const cancelInsurance = () => {
    form.resetFields()
    setHasCard(false)
    setParintInfo({})
    setTradeCntInfo({})
  }

  // 医保挂号
  const medicalSubmit = (vs: any, serverType: any, responseString?: string) => {
    let xyFlag = true;
    selectedDiseases.map((d) => {
      if(isAskMedicine && d.diagType && (d.diagType == 2 || d.diagType == 3 )){
        notification.info({
          message: '医保外配处方请使用西医诊断。',
        })
        xyFlag = false;
        return;
      }
    });

    if(!xyFlag){
      setBtnLoading(false)
      return;
    }
    const treatmentItem: any = departments.find(
      (v) => v.id === vs.registrationDepartmentId
    )
    const doctorItem: any = doctors?.find(
      (v) => v.id === vs.registrationDoctorId
    )

    dispatch(
      medicalRegisterAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          begntime: moment().format(DateTimeFormatSimpleOnlyOne),
          cardType: String(vs.readType) == '11' ? 1 : vs.readType,
          cbxz: patientInsurance.cbxz,
          doctorCode: doctorItem?.countryCode,
          doctorName: doctorItem?.name,
          fullCardInfo: fullCardInfo ? fullCardInfo : '',
          gwybz: patientInsurance.gwybz,
          insuranceRegion: patientInsurance.insuranceRegion,
          psnType: patientInsurance.memberType,
          treatmentDepartmentCode: treatmentItem.code,
          treatmentDepartmentName: treatmentItem.name,
          treatmentNo: vs.treatmentNo || treatmentNum,
          ybKebie: treatmentItem.ybKebie,
          ybPersonalNo: vs.ybPersonalNo,
          name: patientInsurance.name,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              massage: '医保挂号',
            },
            (call: any, err) => {
              if (!err) {
                medicalSubmit(vs, 'response', JSON.stringify(call.netmessage))
              } else {
                setLoading(false)
              }
            }
          )
        } else {
          setYbJiuzhenid(res.ybJiuzhenid)
          // resolve()
          // 挂号
          registerSubmit(
            { ...vs, ybJiuzhenid: res.ybJiuzhenid, receiveTag: 0 },
            undefined
          )
        }
      })
      .catch(() => {
        setLoading(false)
        setBtnLoading(false)
      })
  }

  const registerSubmit = (
    values: Record<string, unknown>,
    params?: PaymentRegistrationParams
  ) => {
    const address = form.getFieldValue('address')
    const codes = form.getFieldValue('area')
    dispatch(reSetRegistration({}))


    const patient = {
      ...P.fromJson(values),
      area: undefined,
      address: address,
      provinceCode: codes?.[0],
      cityCode: codes?.[1],
      contryCode: codes?.[2],
      ageMonth: parseInt(values.ageMonth as string) || 0,
      ageYear: ageUnit === 'month' ? 0 : (parseInt(values.ageYear as string) || 0),
      ageDay: ageUnit === 'month' ? (parseInt(values.ageDay as string) || 0) : 0,
    }
    
    const treatmentAssistantDoctorListItem: any = treatmentAssistantDoctorList?.find(
      (v) => v.id == values?.treatmentAssistantDoctorId
    )
    const registration = {
      ...R.fromJson({
        ...values,
        ybJiuzhenid: values.ybJiuzhenid || ybJiuzhenid,
        treatmentAssistantDoctorId: treatmentAssistantDoctorListItem?.id || '',
        treatmentAssistantDoctorName: treatmentAssistantDoctorListItem?.realname || '',
      }),
    }

    const patientInsuranceItem: any = {
      ...R.patientFromJson(patientInsurance),
      ...otherPatientInsuranceItem,
      fullCardInfo: fullCardInfo || '',
      insuranceCode: insuranceItem?.insuranceCode,
      cardType: String(values.readType) == "11" ? 1 : values.readType,
      dzpzQrCode: qrCode,
      dzpzChnlId: chnlId,
    }
    const department = departments.find(
      (d) => d.id === registration.registrationDepartmentId
    )
    registration.treatmentDepartmentId = registration.registrationDepartmentId
    if (department) {
      registration.registrationDepartmentName = department.name
      registration.treatmentDepartmentName = department.name
    }
    registration.treatmentDoctorId = registration.registrationDoctorId
    const doctor = doctors?.find(
      (d) => d.id === registration.registrationDoctorId
    )
    if (doctor) {
      registration.registrationDoctorName = doctor.name
      registration.treatmentDoctorName = doctor.name
    }
    registration.receiveInAdvance = values.receiveInAdvance ? 1 : 0
    const fee = fees.find((f) => f.id === values.registrationFeeId) as Fee

    dispatch(
      register({
        patient,
        fee,
        payment: params,
        patientInsurance: patientInsuranceItem,
        registration,
        treatmentCategory: values?.treatmentCategory,
        disease: selectedDiseases.map((d) => `${d.name}/${d.icds}`).join(','),
        isQuickSale:1
      })
    )
      .then(unwrapResult)
      .then((data) => {
        setcurrenttreatmentId(data.treatmentId)
        setregistrationId(data.registrationId.toString())
        setCurrentPatientId(data.patientId)
        dispatch(
          getTreatments({
            registrationId: data.registrationId.toString(),
            treatmentId: data.treatmentId.toString(),
            medicalRecord: data.medicalRecord ? data.medicalRecord : (hisVersion == 1 ? 3 : 1) ,
          })
        )
          .then(unwrapResult)
          .then((res: any) => {
            setpatientData(res)
            dispatch(setRecipeEditorTreatment(res?.treatment))
          })

        dispatch(setAppointmentIdSlice(''))
        notification.success({
          message: '挂号成功!',
          duration: 3,
        })
        const vs = form.getFieldsValue()
        setDisable(true) // 按钮禁用
        setHasCard(false)
        if (insuranceItem?.insuranceCode && fee?.hilistCode) {
          FeeListUpR('requestString', data, values)
        }
      })
      .finally(() => {
        setBtnLoading(false)
        setLoading(false)
      })
  }

  const loadState = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 10000)
  }

  useEffect(() => {
    if (recipes.length) {
      // 保留用户当前选择的处方类别；只有该类别不存在时才回退到首张处方。
      // 否则新增中药/处置处方后，列表刷新会把 Tab 强制切回第一张西药处方。
      const hasCurrentCategory = recipes.some(
        (recipe) => recipe.category === category
      )
      if (!hasCurrentCategory) {
        if (recipes?.[0]?.category == RecipeCategory.Medicine || recipes?.[0]?.category == RecipeCategory.Treatment) {
          setCategory(RecipeCategory.Medicine)
        } else if (recipes?.[0]?.category === RecipeCategory.Tcm) {
          setCategory(RecipeCategory.Tcm)
        } else if (recipes?.[0]?.category === RecipeCategory.Dispose) {
          setCategory(RecipeCategory.Dispose)
        }else{
          setCategory(RecipeCategory.Medicine)
        }
      }
    }
  }, [recipes])

  const gotoPayment = () => {
    loadState()
    // 校验诊断字段是否填写（仅在 tenantCityCode 为 320500 时）
    if (String(credentials?.tenantCityCode) === '320500' && form.getFieldValue('registrationCategory') == RegistrationCategory.SelfPay) {
      if ((!selectedDiseasesZIFEI || selectedDiseasesZIFEI.length === 0)) {
        notification.warning({
          message: '必填项未填写',
          description: '诊断为必填项，请先填写诊断',
          placement: 'topRight'
        })
        return
      }
    }
    if (treatment?.insuranceCode !== 'ZIFEI') {
      //查询当前选择的处方，是否是全自费明细，如果是的话，走本地自费结算，否则继续走医保结算
      dispatch(selectIsAllZifeiAsync({ treatmentId: Number(treatment?.id) }))
        .then(unwrapResult)
        .then((res: any) => {
          if (res == 1) {
            linkToPayment()
          } else {
            dispatch(selectTreatmentUpdateFlgsAsync(treatment?.id || ''))
              .then(unwrapResult)
              .then((res: any) => {
                if (res?.insuranceFlag === '0' || res?.insuranceFlag === '2') {
                  // 未上传或已撤销
                  MdtrtinfoUp('requestString', undefined, undefined, undefined)
                } else if (res?.insuranceFlag === '1') {
                  if (res?.updateFlag === '1') {
                    //上传未撤销
                    FeeListUpCancel(
                      'requestString',
                      undefined,
                      undefined,
                      undefined
                    )
                  } else {
                    // 已上传
                    preSettlement(
                      'requestString',
                      undefined,
                      undefined,
                      undefined
                    )
                  }
                }
              })
              .catch(() => {
                if (
                  treatment?.insuranceFlag === '0' ||
                  treatment?.insuranceFlag === '2'
                ) {
                  // 未上传或已撤销
                  MdtrtinfoUp('requestString', undefined, undefined, undefined)
                } else if (treatment?.insuranceFlag === '1') {
                  if (treatment?.updateFlag === '1') {
                    //上传未撤销
                    FeeListUpCancel(
                      'requestString',
                      undefined,
                      undefined,
                      undefined
                    )
                  } else {
                    // 已上传
                    preSettlement(
                      'requestString',
                      undefined,
                      undefined,
                      undefined
                    )
                  }
                }
              })
          }
        })
    } else {
      linkToPayment()
    }
  }

  // 2201
  const medicalSubmitForMultiYidi = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )
    dispatch(
      medicalRegisterForMultiYidiAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem?.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          originRegistrationId: treatment?.registrationId,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              massage: '医保挂号',
            },
            (call: any, err) => {
              if (!err) {
                medicalSubmitForMultiYidi(
                  'response',
                  JSON.stringify(call.netmessage),
                  resolve,
                  reject
                )
              } else {
                setReadLoading(false)
                reject && reject()
              }
            }
          )
        } else {
          MdtrtinfoUp('requestString', undefined, undefined, undefined)
        }
      })
      .catch((v: any) => {
        setReadLoading(false)
        reject && reject()
      })
  }

  // 2203
  const MdtrtinfoUp = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )
    dispatch(
      MdtrtinfoUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem?.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          exp_content: '',
          treatmentId: Number(treatment?.id),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          if ('yidi_to_registration' == res) {
            medicalSubmitForMultiYidi(
              'requestString',
              undefined,
              resolve,
              reject
            )
          } else {
            success('正在上传诊断')
            const data = strParse(res)
            medicalSendHttp(
              {
                trade_args: [
                  data.infno,
                  data.url,
                  data,
                  insuranceItem.countryHospitalNb,
                  insuranceItem.secretToken,
                ],
              },
              (call, err) => {
                if (err) {
                  setLoading(false)
                } else {
                  MdtrtinfoUp('response', JSON.stringify(call.netmessage))
                }
              },
              undefined,
              reject
            )
          }
        } else {
          messageNotification('诊断上传完毕')
          FeeListUp('requestString')
          resolve && resolve()
        }
      })
      .catch((err: any) => {
        setLoading(false)
        reject && reject()
      })
  }

  // 2204
  const FeeListUp = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )
    dispatch(
      FeeListUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          exp_content: '',
          treatmentId: Number(treatment?.id),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setUpdateFlags('1', '0')
        if (serverType === 'requestString') {
          success('正在上传费用')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setUpdateFlags('1', '1')
                setLoading(false)
              } else {
                setUpdateFlags('1', '0'),
                  FeeListUp('response', JSON.stringify(call.netmessage))
              }
            },
            undefined,
            reject
          )
        } else {
          messageNotification('费用上传完毕')
          preSettlement('requestString')
          resolve && resolve()
        }
      })
      .catch(() => {
        resolve && resolve()
        if (serverType === 'response') {
          setUpdateFlags('1', '1')
        }
      })
  }

  // 2205
  const FeeListUpCancel = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )
    dispatch(
      FeeListUpCancelAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          exp_content: '',
          treatmentId: Number(treatment?.id),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('门诊费用明细信息撤销中')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setLoading(false)
              } else {
                setUpdateFlags('2', '0')
                messageNotification('撤销成功')
                MdtrtinfoUp('requestString')
              }

              // FeeListUpCancel('response', JSON.stringify(call.netmessage))
            },
            undefined,
            reject
          )
        } else {
          MdtrtinfoUp('requestString')
          resolve && resolve()
        }
      })
      .catch(() => {
        setLoading(false)
        if (serverType === 'requestString') {
          setUpdateFlags('1', '1')
        }
        resolve && resolve()
      })
  }

  // 2206
  const preSettlement = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === treatment?.insuranceCode
    )

    dispatch(
      preSettlementAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          chrg_bchno: '1',
          exp_content: '',
          treatmentId: treatment?.id,
          patientId: treatment?.patientId,
          registrationId: treatment?.registrationId,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('正在预结算')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setLoading(false)
              } else {
                preSettlement('response', JSON.stringify(call.netmessage))
              }
            },
            undefined,
            reject
          )
        } else {
          // messageNotification('结算成功')
          linkToPayment(res)
          resolve && resolve()
        }
      })
      .catch(() => {
        setLoading(false)
        resolve && resolve()
      })
  }

  // 查询人员累计信息
  const searchPsnSum = (
    isShowModal: boolean,
    serverType: serverType,
    psnNo: string,
    insuranceRegion: string,
    responseString?: string
  ) => {
    dispatch(
      searchPsnSumAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          psnNo,
          insuranceRegion,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              message: '人员累计信息查询',
            },
            (call: any, err) => {
              if (!err) {
                searchPsnSum(
                  isShowModal,
                  'response',
                  psnNo,
                  insuranceRegion,
                  JSON.stringify(call.netmessage)
                )
              } else {
                setSearchPsnSumDisabled(false)
              }
            }
          )
        } else {
          const obj: otherPatientInsuranceItemParams = {}
          if (isShowModal) {
            setSumVisible(true)
            setSumList(res)
          }
          const again = res?.currYearInsCumWithoutYear.filter((v: any) => {
            return (
              v.name === '大病补充起付金额累计' ||
              v.name === '门诊起付金额累计' ||
              v.name === '门诊慢病起付金额累计'
            )
          })
          again.forEach((v: any) => {
            if (v.name === '大病补充起付金额累计') {
              obj.dbbcqflj = v.cum
            } else if (v.name === '门诊起付金额累计') {
              obj.dnqfxljPt = v.cum
            } else if (v.name === '门诊慢病起付金额累计') {
              obj.dnqfxljMb = v.cum
            }
          })
          setOtherPatientInsuranceItem(obj)
          setSearchPsnSumDisabled(false)
        }
      })
      .catch(() => {
        setSearchPsnSumDisabled(false)
      })
  }

  const setUpdateFlags = (insuranceFlag: string, updateFlag: string) => {
    if (insuranceFlag === '1' && updateFlag === '1') {
      setLoading(false)
    }
    dispatch(
      setUpdateFlagsAsync({
        treatmentId: treatment?.id,
        insuranceFlag,
        updateFlag,
      })
    )
      .then(unwrapResult)
      .then(() => {
        getTreatmentsDetail()
      })
  }

  const getTreatmentsDetail = () => {
    dispatch(
      getTreatments({
        registrationId,
        treatmentId,
      })
    )
      .then(unwrapResult)
      .then((v) => {
        setpatientData(v)
      })
  }

  const messageNotification = async (str: string) => {
    await message.destroy()
    notification.success({
      message: str,
      duration: 1,
    })
  }

  const readMessage = () => {
    if (hasCard) {
      notification.info({
        message: '医保信息只读，不可修改',
        duration: 1,
      })
    }
  }

  const isSee = (idCard?: string, name?: string, phone?: number) => {
    //查询是否就诊
    dispatch(
      getIsSeeDoctor({
        idCard: idCard ? idCard : undefined,
        name,
        phone,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        form.setFieldsValue({
          receiveTag: res.receiveTag,
        })
      })
  }

  useEffect(() => {
    if (isHisCode) {
      setDiabled(true)
       form.setFieldsValue({
        treatmentNo: treatmentNum,
      })
    }
  }, [isHisCode,treatmentNum])

  useEffect(() => {
    if (keyword) {
      form.setFieldsValue({
        name: keyword,
      })
    }
  }, [keyword])

  useEffect(() => {
    form.setFieldsValue({
      treatmentCategory: TreatmentCategory.Normal,
      disease: '',
    })
  }, [dispatch])

  useEffect(() => {
    if (patient && !isHisCode) {
      setFiles(patient)
    } else if (membersInfo?.patient && !isHisCode && !form.getFieldValue('name')) {
      patientAutoFilled.current = true
      setFiles(membersInfo?.patient)
      form.setFieldsValue({
        treatmentNo: membersInfo?.patient?.id,
      })
      setDisable(true)
    }
  }, [dispatch, patient, membersInfo, isHisCode, treatmentNum])

  const setFiles =(patient: any)=>{
     console.log(patient,"membersInfo")
    setPatientId(patient.id)
    const isAgeBothZero = Number(patient?.ageYear) === 0 && Number(patient?.ageMonth) === 0
    form.setFieldsValue({
        ...patient,
        phone: patient?.phone ? (!KSKDCKHRSJHData ? getMaskPhone(decrypt(patient.phone)) : decrypt(patient.phone)) : undefined,
        ageYear: isAgeBothZero ? '' : patient?.ageYear,
        ageMonth: isAgeBothZero ? '' : (parseInt(patient?.ageMonth as string) || '1'),
        address: patient?.address || patient?.companyName,
        area: patient?.provinceCode && patient?.provinceCode != 0
        ? [
          Number(patient?.provinceCode),
          Number(patient?.cityCode),
          Number(patient?.contryCode),
        ] : [],
        birthday: patient.birthday
          ? moment(patient.birthday).format(DateTimeFormatSimple)
          : '',
      })
      if (patient?.birthday) {
        updateYearsAndMonths()
      }
      setPhoneDisabled(patient?.phone && !KSKDCKHRSJHData)
      setKeyword(patient.name)
      dispatch(setPatient(undefined))
      const obj = {
        ...localObj,
        ageMonth: isAgeBothZero ? '' : (parseInt(patient?.ageMonth as string) || '0'),
        ageYear: isAgeBothZero ? '' : patient?.ageYear,
        ageDay: patient?.ageDay || 0,
        birthday: patient?.birthday,
        patientId: patient?.id,
        patientName: patient?.name,
        patientSex: patient?.sex,
        phone: patient?.phone,
        treatmentNo: treatmentNum || patient?.id,
        address: patient?.address || patient?.companyName,
        provinceCode: patient?.provinceCode,
        cityCode: patient?.cityCode,
        contryCode: patient?.contryCode,
      }
      setLocalObj(obj)
      setPatientObj({ ...patientObj, ...obj })
      localStorage.setItem('localObj', JSON.stringify(obj))
  }

  const getNotice = (patientId:any) =>{
    setNotice(undefined)
    dispatch(getTreatmentNotice(patientId))
      .then(unwrapResult)
      .then((notice) => setNotice(notice))
      .catch(() => {
         // do nothing
       })
  }

  const searchMember = (phone: any) => {
    dispatch(getSearchMembersByPhone({ keyword: phone }))
      .then(unwrapResult)
      .then((res) => {
        setMembersInfo(res?.[0])
        setSearchMembersBtnText(1)
      })
  }

  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients.map((p) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            form.setFieldsValue({
              treatmentNo: p.id,
            })
            setDisable(true)
            dispatch(setTreatmentId(undefined))
            setRecipes([])
            setcurrenttreatmentId(0)
            setAppointmentId('')
            patientAutoFilled.current = false
            setIsPatientOverlayVisible(false)
            dispatch(getPatientDetail(p.id))
            getNotice(p?.id)
            if (p?.phone) {
              searchMember(p.phone)
            }
          }}
        >
          <Space>
            <span>{p.name}</span>
            <span>{getGenderName(p.sex)}</span>
            <span>{getAge(p.ageYear, p.ageMonth, '岁', p.ageDay)}</span>
            {p.phone && (
              <span>
                {!KSKDCKHRSJHData ? getMaskPhone(p.phone) : p.phone}
              </span>
            )}
            <span>{p.id}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  // 历史患者/患者姓名搜索
  useEffect(() => {
    if (!isHisCode) {
      dispatch(getPatientList(keyword))
    }
  }, [dispatch, keyword, isHisCode])

  useEffect(() => {
    if (location.state) {
      dispatch(setCurrentTab(location.state.selectKey))
    }
  }, [location.state])

  const diseasesChose = (v: any) => {
    switch (v.diseTypeCode) {
      case '12':
        form.setFieldsValue({
          treatmentCategory: TreatmentCategory.Special,
        })
        break
      case '11':
        form.setFieldsValue({
          treatmentCategory: TreatmentCategory.Slow,
        })
        break
      case '14':
        form.setFieldsValue({
          treatmentCategory: TreatmentCategory.SlowAndSpecial,
        })
        break
      default:
        // if (
        //   form.getFieldValue('treatmentCategory') ==
        //     TreatmentCategory.Special ||
        //   form.getFieldValue('treatmentCategory') == TreatmentCategory.Slow ||
        //   form.getFieldValue('treatmentCategory') ==
        //     TreatmentCategory.SlowAndSpecial
        // ) {
        //   form.setFieldsValue({
        //     treatmentCategory: TreatmentCategory.Normal,
        //   })
        // }
        form.resetFields(['disease'])
        break
    }
  }


  const useSetting = (type: any) => {
    const no = form.getFieldValue('treatmentNo')
    if (!no) {
      //1.根据偏好设置获取挂号类别（如果没有则取自费）
      const item = insuranceArray?.filter(
        (v: any) => v.insuranceCode == ghlb
      )?.[0]
      // 西药处置中药
      if (xzcf == '0') {
        setCategory(RecipeCategory.Medicine)
      } else if (xzcf == '1'){
        setCategory(RecipeCategory.Tcm)
      } else if (xzcf == '2'){
        setCategory(RecipeCategory.Dispose)
      }else {
        setCategory(RecipeCategory.Medicine)
      }
      if(tenantCategory==16){
        setCategory(RecipeCategory.Medicine)
      }
      if (ghlb == 'ZIFEI' || !item) {
        form.setFieldsValue({
          registrationCategory: 0,
        })
        setHasCard(false)
        setIsHisCode(false)
        setInsuranceItem({})
        setValue(0)
        setParintInfo({})
        setTradeCntInfo({})
      }
      //2.根据偏好设置获取性别，如果没有就默认未知 1:男，2:女，0:未知
      const registrationCategory = form.getFieldValue('registrationCategory')
      if (registrationCategory == RegistrationCategory.SelfPay) {
        form.setFieldsValue({
          sex: hzxb,
        })
      } else if ('noInsuranceCheck' != type) {
        const insuranceCode = form.getFieldValue('registrationCategory')?.insuranceCode
        //否则，判断当前的类型是否和偏好设置一样，如果不一样则设置，一样就忽略（不能直接设置value未item，否则会选不中）
        if (insuranceCode != item?.insuranceCode) {
          form.setFieldsValue({
            registrationCategory: item || 0,
          })
        }
        if (insuranceCode != 'ZIFEI') {
          setIsHisCode(true)
          setInsuranceItem(item)
          setValue(item)
          form.setFieldsValue({
            readType: 1,
          })
        }
      }
    }
  }

  useEffect(() => {
    dispatch(getRankingListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(setRankingList(res))
      })
  }, [])

  // 保存疾病
  const saveDisease = (disease?:any)=>{
    dispatch(getSaveDiseaseAsync({
      registrationId:registrationId,
      treatmentId:currenttreatmentId,
      disease:disease,
    })).then(unwrapResult).then((v)=>{
      notification.success({
        message:'操作成功'
      })
    })
  }

  return (
    <Col
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        position: 'relative',
      }}
    >
      <GlobalKeyboardAction
        onSpacePress={() => {
          if (!recipes.filter(isRecipePayable).length || isAskMedicine || currentTab == '1') {
            return
          }
          const runButtonLogic = () => {
            // 非快速开单空格键
            if (editMedicalVisible == 'false') {
              if (!tipsCount) {
                notification.info({
                  message: '请输入正确的帖数。',
                })
              } else {
                if (!isInsurance) {
                  submit(recipes) // 自费
                } else {
                  // 医保
                  if (treatment) {
                    dispatch(checkTreatmentAsync(treatment.id))
                      .then(unwrapResult)
                      .then(() => {

                        //医保开启了自动提醒
                        if (settings?.[SettingChecks.YBSQZDTX]) {
                          setIsAutoRemind(true)
                          beforeAlert('requestString','',true)
                        } else {
                          gotoPayment()
                        }
                      })
                  }
                }
              }
            }
          }
          checkOverOnlineLimit(runButtonLogic)
        }}
      />
      <TabBar
        style={{ position: 'relative', margin: '10px 20px', flex: 1 }}
        defaultActiveKey={currentTab}
        activeKey={currentTab}
        onChange={(key) => dispatch(setCurrentTab(key))}
      >
        {menuList?.subMenus?.map((v: any) => {
          return (
            <>
              <TabPane
                key={getKeys(v?.name)}
                tab={
                  isAskMedicine && v?.name == '快速开单'
                    ? '处方申请'
                    : isAskMedicine && v?.name == '收费明细'
                    ? '处方申请记录'
                    : v?.name
                }
               
              >
                {v?.name == '快速开单' ? (
                  <Col
                    style={{
                      display: 'flex',
                      width: '100%',
                      borderRadius: 8,
                      height: 'calc(100%)',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      className={styles.register}
                      style={{
                        padding: '0',
                        borderRadius: '8px',
                        height: 'calc(100%)',
                      }}
                    >
                      <div style={{
                          flex: 1,
                          width: '254px',
                          height: '100%',
                          marginTop: 10,
                          borderRadius: '8px',
                          backgroundColor: theme.pn,
                          overflow:'hidden',
                          padding: '10px',
                          marginRight: 10,
                        }}>
                      <Form
                        form={form}
                        autoComplete='off'
                        colon={false}
                        labelAlign='right'
                        onFinishFailed={(errorInfo) =>{
                          console.log('校验失败，进入onFinishFailed:', errorInfo); // 重点看这里

                        }} // 新增失败回调

                        onFinish={(values) => {
                          setPatientObj({ ...parintInfo, ...values })
                          if (values.registrationCategory) {
                            if (hasCard) {
                              if (!selectedDiseases.length) {
                                notification.error({
                                  message: '请输入主要疾病',
                                })
                                return
                              }
                              setBtnLoading(true)
                              medicalSubmit(values, 'requestString')
                            } else {
                              notification.error({
                                message: '请先读卡',
                                duration: 1,
                              })
                            }
                          }
                        }}
                        style={{
                          width:'100%',
                          height: !isHisCode ? '94%' : '100%',
                          overflowY:'auto',
                          overflowX:'hidden'
                        }}
                        {...layout}
                      >
                        <Row
                          style={{
                            fontWeight: 'bold',
                            fontSize: '18px',
                            marginLeft: 10,
                            marginBottom: 0,
                          }}
                        >
                          <span>患者信息</span>
                          {parintInfo &&
                            !!Object.keys(parintInfo).length &&
                            !messageFlag && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  margin: '0px 0 0 10px',
                                  paddingTop: '5px',
                                }}
                              >
                                {patientInsurance?.ybType?.toString() ? (
                                  <div
                                    style={{
                                      fontSize: '14px',
                                      color: 'rgb(7, 193, 96)',
                                    }}
                                  >
                                    {getYBTypeName(
                                      patientInsurance?.ybType?.toString()
                                    )}
                                  </div>
                                ) : (
                                  ''
                                )}
                                {patientInsurance?.patientId?.toString() ? (
                                  <div
                                    style={{
                                      fontSize: '14px',
                                      color: '#FAB714',
                                      marginLeft: '20px',
                                    }}
                                  >
                                    {patientInsurance?.patientId == -1
                                      ? '本年首次'
                                      : notice?.isFirstDiagnosisThisYear
                                      ? '本年首次'
                                      : '本年复诊'}
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            )}
                        </Row>
                        <Row className={styles.contentFB}>
                          <Col span={24}>
                            <Form.Item
                              label='费别'
                              name='registrationCategory'
                              {...{
                                labelCol: { span: 5 },
                                wrapperCol: { span: 19 },
                              }}
                            >
                              <Radio.Group
                                value={value}
                                onChange={(v) => {
                                  setValue(v.target.value)
                                  setAgeUnit('year')
                                  form.setFieldsValue({
                                    ageYear: '',
                                    ageMonth: '',
                                    ageDay: '',
                                    birthday: '',
                                    sex: 0,
                                    phone: '',
                                    name: '',
                                    address:'',
                                    area: [],
                                    treatmentNo: '',
                                  })
                                  setKeyword('')
                                  setDiabled(false)
                                  setSelectedDiseasesZIFEI([])
                                  if (v.target.value == 0) {
                                    useSetting('noInsuranceCheck')
                                  }
                                }}
                                style={{ width: '100%' }}
                                disabled={disable || materials.length != 0}
                              >
                                <Radio
                                  value={RegistrationCategory.SelfPay}
                                  key={RegistrationCategory.SelfPay}
                                  onClick={() => {
                                    setLocalObj({})
                                    setPatientObj({})
                                    setPatientInsurance({})
                                    setIsHisCode(false)
                                    setInsuranceItem({})
                                    cancelInsurance()
                                    setRecipes([])
                                    setcurrenttreatmentId(0)
                                    useSetting('noInsuranceCheck')
                                  }}
                                >
                                  自费
                                </Radio>
                                {insuranceArray.length !== 0 &&
                                  insuranceArray.map((v: MedicelListValue) => (
                                    <Radio
                                      key={v.id}
                                      value={v}
                                      onClick={(e) => {
                                        setIsHisCode(true)
                                        setInsuranceItem(v)
                                        setRecipes([])
                                        setcurrenttreatmentId(0)
                                        form.setFieldsValue({
                                          readType: 1,
                                        })
                                      }}
                                    >
                                      {v.insuranceName}
                                    </Radio>
                                  ))}
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                          {/* {isHisCode && (
                            <>
                              <Button
                                type='primary'
                                disabled={
                                  patientBtn ||
                                  (!patientObj && materials.length != 0) ||
                                  form.getFieldValue('registrationCategory') != 0
                                }
                                onClick={() => {
                                  setPatientModalVisible(true)
                                }}
                              >
                                完善病历信息
                              </Button>
                            </>
                          )} */}
                        </Row>
                        <div>
                          {isHisCode && (
                            <>
                              <span
                                style={{ paddingRight: 10, marginLeft: '20px' }}
                              >
                                读卡
                              </span>
                              <Form.Item
                                noStyle
                                name='readType'
                                style={{
                                  marginLeft: 0,
                                }}
                              >
                                <Select
                                  dropdownMatchSelectWidth={120}
                                  disabled={hasCard || disable}
                                  style={{
                                    width: '100px',
                                    color: theme.tc3,
                                    height: 32,
                                    // marginLeft: 10,
                                    marginTop: 5,
                                    marginBottom: 0,
                                    backgroundColor: theme.c3,
                                    border: 'none',
                                  }}
                                  size='middle'
                                  // suffixIcon={<CaretDownFilled />}
                                  options={insuranceItem?.ybFaceRecognition == 1 ? readTypesPlusFace:readTypes}
                                />
                              </Form.Item>
                              <Button
                                style={{
                                  color: '#fff',
                                  height: 32,
                                  backgroundColor: '#11a9cb',
                                  border: 'none',
                                  padding: '2px 5px',
                                }}
                                onClick={() => {
                                  readCard()
                                }}
                                ref={readCardRef}
                                loading={readLoading}
                                disabled={disable}
                              >
                                读卡
                              </Button>
                              <Button 
                              style={{width: '30px',marginLeft: '-12px'}}
                                type='link'
                                disabled={materials.length != 0}
                                onClick={(()=>{
                                  clearYBForm()
                                })}
                              >清空</Button>
                            </>
                          )}
                          <Row>
                            <Col
                              span={24}
                              style={{
                                marginTop: 5,
                              }}
                            >
                              <Form.Item label='病历号' name='treatmentNo'>
                                <Input disabled />
                              </Form.Item>
                            </Col>
                          </Row>
                          {(form.getFieldValue('registrationCategory') == 0 ||
                            messageFlag) && (
                            <>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={20}>
                                  <Form.Item
                                    required
                                    label='姓名'
                                    name='name'
                                    {...{
                                      labelCol: { span: 7 },
                                      wrapperCol: { span: 17 },
                                    }}
                                    rules={[
                                      {
                                        required: true,
                                        max: 40,
                                        message: '请输入患者姓名',
                                      },
                                    ]}
                                  >
                                    {!isHisCode ? (
                                      <Dropdown
                                        disabled={
                                          disable ||
                                          obj.state == 1 ||
                                          materials.length != 0
                                        }
                                        overlay={patientOverlay}
                                        visible={isPatientOverlayVisible}
                                      >
                                        <Input
                                          autoFocus
                                          disabled={
                                            disable ||
                                            obj.state == 1 ||
                                            materials.length != 0
                                          }
                                          readOnly={
                                            disable ||
                                            obj.state == 1 ||
                                            materials.length != 0
                                          }
                                          style={{ marginLeft: 1 }}
                                          allowClear
                                          placeholder={'姓名/性别/手机号'}
                                          prefix={
                                            <SearchOutlined
                                              style={{ color: theme.tc3 }}
                                            />
                                          }
                                          value={keyword}
                                          onFocus={() => {
                                            dispatch(getPatientList(keyword))
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setIsPatientOverlayVisible(false)
                                            }, 300)
                                          }}
                                          onClick={() => {
                                            setIsPatientOverlayVisible(true)
                                          }}
                                          onChange={(e) => {
                                            setIsPatientOverlayVisible(true)
                                            setKeyword(e.target.value)
                                            const obj = {
                                              ...localObj,
                                              patientName: e.target.value,
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({
                                              ...patientObj,
                                              ...obj,
                                            })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                        />
                                      </Dropdown>
                                    ) : (
                                      <Input
                                        disabled={
                                          diabled ||
                                          obj.state == 1 ||
                                          materials.length != 0
                                        }
                                        readOnly={
                                          diabled ||
                                          obj.state == 1 ||
                                          materials.length != 0
                                        }
                                        autoFocus
                                        onClick={() => readMessage()}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={4}>
                                  <Button
                                    disabled={materials.length != 0}
                                    style={{
                                      padding: 0,
                                      marginLeft: 8,
                                    }}
                                    type='link'
                                    onClick={() => {
                                      clearZifeiForm()
                                    }}
                                  >
                                    清空
                                  </Button>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                    label='手机号'
                                    name='phone'
                                    rules={[{ ...phonePattern }]}
                                    >
                                      <Input
                                        maxLength={11}
                                        disabled={materials.length != 0 || phoneDisabled && localObj?.phone}
                                        onChange={(v) => {
                                          const obj = {
                                            ...localObj,
                                            phone: v?.target?.value,
                                          }
                                          setLocalObj(obj)
                                          setPatientObj({ ...patientObj, ...obj })
                                          localStorage.setItem(
                                            'localObj',
                                            JSON.stringify(obj)
                                          )
                                          if(v?.target?.value && v?.target?.value.length == 11){
                                            searchMember(v?.target?.value)
                                          }
                                        }}
                                        suffix={
                                          phoneDisabled ? (
                                            <CloseCircleFilled
                                              onClick={() => {
                                                form.setFieldsValue({ phone: '' })
                                                setPhoneDisabled(false)
                                              }}
                                              style={{ color: '#999', cursor: 'pointer' }}
                                            />
                                          ) : null
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    label='年龄'
                                    {...{
                                      labelCol: { span: 6 },
                                    }}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      flexWrap: 'nowrap',
                                      // marginRight: '40px',
                                    }}
                                    required
                                  >
                                    <Row wrap={false} align='middle'>
                                      <Form.Item
                                        key={`age-first-${ageUnit}`}
                                        name={ageUnit === 'month' ? 'ageMonth' : 'ageYear'}
                                        noStyle
                                        dependencies={ageUnit === 'month' ? ['ageDay'] : ['ageMonth']}
                                        rules={[
                                          {
                                            pattern: ageUnit === 'month' ? /^(1[01]|[0-9])$/ : /^(200|[01]?[0-9]{1,2})$/,
                                            message: ageUnit === 'month' ? '请输入正确的月份' : '请输入正确的年龄',
                                          },
                                          ({ getFieldValue }) => ({
                                            validator: (_, value) => {
                                              const secondField = ageUnit === 'month' ? getFieldValue('ageDay') : getFieldValue('ageMonth')
                                              if ((!value && value !== 0) && (!secondField && secondField !== 0)) {
                                                return Promise.reject(
                                                  new Error('请输入正确的年龄')
                                                )
                                              }
                                              return Promise.resolve()
                                            },
                                          }),
                                        ]}
                                      >
                                        <Input
                                          disabled={
                                            isHisCode || materials.length != 0
                                          }
                                          readOnly={
                                            isHisCode || materials.length != 0
                                          }
                                          onClick={() => readMessage()}
                                          onChange={(v: any) => {
                                            updateBirthday()
                                            const fieldKey = ageUnit === 'month' ? 'ageMonth' : 'ageYear'
                                            const obj = {
                                              ...localObj,
                                              [fieldKey]: Number(v?.target?.value),
                                              birthday: form.getFieldValue(
                                                'birthday'
                                              ),
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({
                                              ...patientObj,
                                              ...obj,
                                            })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                          style={{ maxWidth: '3rem' }}
                                        />
                                      </Form.Item>
                                      <Dropdown
                                        disabled={isHisCode || materials.length != 0}
                                        trigger={['click']}
                                        overlay={
                                          <Menu
                                            selectedKeys={[ageUnit]}
                                            onClick={({ key }) => {
                                              if (key !== ageUnit) {
                                                const newUnit = key as 'year' | 'month'
                                                const rawFirst = form.getFieldValue(ageUnit === 'month' ? 'ageMonth' : 'ageYear')
                                                const rawSecond = form.getFieldValue(ageUnit === 'month' ? 'ageDay' : 'ageMonth')
                                                if (newUnit === 'month') {
                                                  form.setFieldsValue({ ageMonth: rawFirst, ageDay: rawSecond })
                                                  setAgeUnit('month')
                                                  const months = parseInt(rawFirst) || 0
                                                  const days = parseInt(rawSecond) || 0
                                                  if (months || days) {
                                                    const birthday = moment().subtract(months, 'months').subtract(days, 'days').format('YYYY/MM/DD')
                                                    form.setFieldsValue({ birthday })
                                                    const obj = { ...localObj, birthday, ageYear: 0, ageMonth: months, ageDay: days }
                                                    setLocalObj(obj)
                                                    setPatientObj({ ...patientObj, ...obj })
                                                    localStorage.setItem('localObj', JSON.stringify(obj))
                                                  }
                                                  setTimeout(() => {
                                                    if (rawFirst || rawSecond) {
                                                      form.validateFields(['ageMonth', 'ageDay'])
                                                    }
                                                  }, 100)
                                                } else {
                                                  form.setFieldsValue({ ageYear: rawFirst, ageMonth: rawSecond })
                                                  setAgeUnit('year')
                                                  const years = parseInt(rawFirst) || 0
                                                  const months = parseInt(rawSecond) || 0
                                                  if (years || months) {
                                                    const birthday = moment().subtract(years, 'years').subtract(months, 'months').format('YYYY/MM/DD')
                                                    form.setFieldsValue({ birthday })
                                                    const obj = { ...localObj, birthday, ageYear: years, ageMonth: months, ageDay: 0 }
                                                    setLocalObj(obj)
                                                    setPatientObj({ ...patientObj, ...obj })
                                                    localStorage.setItem('localObj', JSON.stringify(obj))
                                                  }
                                                  setTimeout(() => {
                                                    if (rawFirst || rawSecond) {
                                                      form.validateFields(['ageYear', 'ageMonth'])
                                                    }
                                                  }, 100)
                                                }
                                              }
                                            }}
                                            style={{ minWidth: 50 }}
                                          >
                                            <Menu.Item key="year">岁</Menu.Item>
                                            <Menu.Item key="month">月</Menu.Item>
                                          </Menu>
                                        }
                                      >
                                        <div
                                          style={{
                                            color: theme.tc2,
                                            fontSize: '1rem',
                                            margin: '0 6px',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          {ageUnit === 'year' ? '岁' : '月'}
                                          <CaretDownFilled style={{ fontSize: '0.7rem', marginLeft: 2 }} />
                                        </div>
                                      </Dropdown>
                                      <Form.Item
                                        key={`age-second-${ageUnit}`}
                                        name={ageUnit === 'month' ? 'ageDay' : 'ageMonth'}
                                        noStyle
                                        dependencies={ageUnit === 'month' ? ['ageMonth'] : ['ageYear']}
                                        rules={[
                                          ageUnit === 'month'
                                            ? { pattern: /^\d{0,2}$/, message: '请输入正确的天数' }
                                            : { pattern: /^(0?[0-9]|1[0-1])$/, message: '请输入正确的月份' },
                                        ]}
                                      >
                                        <Input
                                          disabled={
                                            isHisCode || materials.length != 0
                                          }
                                          readOnly={
                                            isHisCode || materials.length != 0
                                          }
                                          onClick={() => readMessage()}
                                          onChange={(v) => {
                                            updateBirthday()
                                            const fieldKey = ageUnit === 'month' ? 'ageDay' : 'ageMonth'
                                            const obj = {
                                              ...localObj,
                                              [fieldKey]: Number(v?.target?.value),
                                              birthday: form.getFieldValue(
                                                'birthday'
                                              ),
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({
                                              ...patientObj,
                                              ...obj,
                                            })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                          style={{ maxWidth: '3rem' }}
                                        />
                                      </Form.Item>
                                      <div
                                        style={{
                                          color: theme.tc2,
                                          fontSize: '1rem',
                                          margin: '0 6px',
                                        }}
                                      >
                                        {ageUnit === 'year' ? '月' : '天'}
                                      </div>
                                    </Row>
                                    <Row style={{ marginTop: 5 }}>
                                      <Form.Item
                                        {...thirdColumnLayout}
                                        name='birthday'
                                        noStyle
                                          style={{ flex: 1 }}
                                          rules={[
                                            { max: 10, message: '最多10个字' },
                                            () => ({
                                              validator(_, value) {
                                                if (!value) return Promise.resolve()
                                                const str = String(value)
                                                if (!/^(?:1\d{3}|2\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})\/(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/.test(str)) {
                                                  return Promise.reject(new Error('格式参考:19980808'))
                                                }
                                                const digits = str.replace(/[-/]/g, '')
                                                const now = new Date()
                                                const todayStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`
                                                if (digits > todayStr) {
                                                  form.setFieldsValue({
                                                    ageYear: '',
                                                    age: '',
                                                    ageMonth: '',
                                                    ageDay: '',
                                                  })
                                                  return Promise.reject(new Error('出生日期填写不对'))
                                                }
                                                return Promise.resolve()
                                              },
                                            }),
                                          ]}
                                        >
                                          <Input
                                          onChange={(v) => {
                                            updateYearsAndMonths()
                                            const obj = {
                                              ...localObj,
                                              birthday: v?.target?.value,
                                              ageYear: ageUnit === 'year' ? parseInt(form.getFieldValue('ageYear')) : 0,
                                              ageMonth: parseInt(form.getFieldValue('ageMonth')),
                                              ageDay: ageUnit === 'month' ? parseInt(form.getFieldValue('ageDay')) : 0,
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({
                                              ...patientObj,
                                              ...obj,
                                            })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                          disabled={
                                            isHisCode || materials.length != 0
                                          }
                                          readOnly={
                                            isHisCode || materials.length != 0
                                          }
                                          onClick={() => readMessage()}
                                        />
                                      </Form.Item>
                                    </Row>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    {...required}
                                    label='性别'
                                    name='sex'
                                    {...{
                                      labelCol: {
                                        span: 6,
                                      },
                                      wrapperCol: {
                                        span: 18,
                                      },
                                    }}
                                  >
                                    <Radio.Group
                                      disabled={
                                        hasCard || materials.length != 0
                                      }
                                      onChange={(v) => {
                                        const obj = {
                                          ...localObj,
                                          patientSex: v?.target?.value,
                                        }
                                        setLocalObj(obj)
                                        setPatientObj({ ...patientObj, ...obj })
                                        localStorage.setItem(
                                          'localObj',
                                          JSON.stringify(obj)
                                        )
                                      }}
                                    >
                                      {[
                                        Gender.Male,
                                        Gender.Female,
                                        Gender.Unknown,
                                      ].map((g) => (
                                        <Radio key={g} value={g}>
                                          {getGenderName(g)}
                                        </Radio>
                                      ))}
                                    </Radio.Group>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item name='area' label='家庭地区'>
                                    <Cascaded
                                      disabled={
                                        hasCard || materials.length != 0
                                      }
                                      allowClear={false}
                                      // loadData={loadData}
                                      options={allList}
                                      placeholder='请选择'
                                      onChange={(v:any) => {
                                        const obj = {
                                          ...localObj,
                                          provinceCode: v?.[0],
                                          cityCode: v?.[1],
                                          contryCode: v?.[2],
                                        }
                                        setLocalObj(obj)
                                        setPatientObj({ ...patientObj, ...obj })
                                        localStorage.setItem(
                                          'localObj',
                                          JSON.stringify(obj)
                                        )
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                    label='地址'
                                    name='address'
                                  >
                                    <Input
                                      placeholder='请输入'
                                      disabled={
                                        hasCard || materials.length != 0
                                      }
                                      maxLength={250}
                                      onChange={(v) => {
                                        const obj = {
                                          ...localObj,
                                          address: v?.target?.value,
                                        }
                                        setLocalObj(obj)
                                        setPatientObj({ ...patientObj, ...obj })
                                        localStorage.setItem(
                                          'localObj',
                                          JSON.stringify(obj)
                                        )
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    rules={[
                                      {
                                        // required: true,
                                        max: 40,
                                        // message: '请选择医生科室',
                                      },
                                    ]}
                                    label='科室'
                                    name='ZIFEIregistrationDepartmentId'
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                  >
                                    <Select
                                      allowClear
                                      placeholder='请选择'
                                      disabled={materials.length != 0}
                                      // suffixIcon={
                                      //   <CaretDownFilled
                                      //     style={{ color: theme.tc3 }}
                                      //   />
                                      // }
                                      onChange={(id: string) => {

                                        form.setFieldsValue({
                                          registrationDoctorId: undefined,
                                          ZIFEIregistrationDoctorId: '',
                                        })
                                        if (id) {
                                          getDoctorList(id,credentials?.isAskMedicine)
                                        } else {
                                          setDoctors([])
                                        }
                                        const obj = {
                                          ...localObj,
                                          treatmentDepartmentId: id || undefined,
                                          treatmentDepartmentName: id ? departments?.filter(
                                            (v: any) => v.id == id
                                          )[0]?.name : undefined,
                                          treatmentDoctorId: id ? localObj?.treatmentDoctorId : undefined,
                                          treatmentDoctorName: id ? localObj?.treatmentDoctorName : undefined,
                                        }

                                        setLocalObj(obj)
                                        setPatientObj({ ...patientObj, ...obj })
                                        localStorage.setItem(
                                          'localObj',
                                          JSON.stringify(obj)
                                        )
                                      }}
                                    >
                                      {departments.map((d) => (
                                        <Select.Option key={d.id} value={d.id}>
                                          {d.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24} className={styles.selectDisplay}>
                                  <Form.Item
                                    label='医生'
                                    name='ZIFEIregistrationDoctorId'
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                    rules={[
                                      {
                                        // required: true,
                                        max: 40,
                                        // message: '请输入医生',
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder='请选择'
                                      showSearch
                                      allowClear
                                      disabled={materials.length != 0}
                                      // suffixIcon={
                                      //   <CaretDownFilled
                                      //     style={{ color: theme.tc3 }}
                                      //   />
                                      // }
                                      onChange={(id: string) => {
                                        if (!id) {
                                          setFlag(true)
                                        } else {
                                          setFlag(false)
                                        }
                                        const obj = {
                                          ...localObj,
                                          treatmentDoctorId: id,
                                          treatmentDoctorName: doctors?.filter(
                                            (v: any) => v.id == id
                                          )[0]?.name,
                                        }
                                        setLocalObj(obj)
                                        setPatientObj({ ...patientObj, ...obj })
                                        localStorage.setItem(
                                          'localObj',
                                          JSON.stringify(obj)
                                        )
                                      }}
                                      filterOption={(input, option) => {
                                        return option?.className
                                          ? ((option?.className as unknown) as string)
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          : false
                                      }}
                                    >
                                      {doctors?.map((d) => (
                                        <Select.Option
                                          className={d.mnemonicCode}
                                          key={d.id}
                                          value={d.id}
                                        >
                                         <span>{d.name} </span>
                                         {d?.lastRegTime ? <span>（</span> : ''}
                                          <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                                          {d?.lastRegTime ? <span>）</span> : ''} 
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                </Row>
                                {tenantCategory == 16 ?
                                  <Row
                                    style={{
                                      marginTop: 5,
                                    }}
                                  >
                                    <Col span={24} className={styles.selectDisplay}>
                                      <Form.Item
                                        label='助理'
                                        name='treatmentAssistantDoctorId'
                                        {...{
                                          labelCol: { span: 6 },
                                          wrapperCol: { span: 18 },
                                        }}
                                      >
                                        <Select
                                          placeholder='请选择'
                                          showSearch
                                          allowClear
                                          disabled={materials.length != 0}
                                          onChange={(id: string) => {
                                            if (!id) {
                                              setFlag(true)
                                            } else {
                                              setFlag(false)
                                            }
                                            const obj = {
                                              ...localObj,
                                              treatmentAssistantDoctorId: id,
                                              treatmentAssistantDoctorName: treatmentAssistantDoctorList?.filter(
                                                (v: any) => v.id == id
                                              )[0]?.realname,
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({ ...patientObj, ...obj })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                          filterOption={(input, option) => {
                                            return option?.className
                                              ? ((option?.className as unknown) as string)
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                              : false
                                          }}
                                        >
                                          {treatmentAssistantDoctorList?.map((d) => (
                                            <Select.Option
                                              className={d.mnemonicCode}
                                              key={d.id}
                                              value={d.id}
                                            >
                                              <span>{d.realname}</span>
                                              {d?.lastRegTime ? <span>（</span> : ''}
                                              <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                                              {d?.lastRegTime ? <span>）</span> : ''}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row> : <></>}

                                <Row
                                  style={{
                                    marginTop: 5,
                                  }}
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      label={!isAskMedicine ?'诊断' : '初步诊断'}
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                    name='ZIFEIdisease'
                                    required={String(credentials?.tenantCityCode) === '320500'}
                                  >
                                    <Row
                                      wrap={false}
                                      style={{ height: '40px' }}
                                      gutter={10}
                                    >
                                      <Col
                                        span={24}
                                        className={styles.overDisease}
                                      >
                                        <DiseaseInput
                                          isAskMedicine={credentials?.isAskMedicine || 0}
                                          isMedical={1}
                                          autoFocus={
                                            selectedDiseasesZIFEI?.length
                                              ? true
                                              : false
                                          }
                                          // disabled={
                                          //   !isDiseaseEditable ||
                                          //   materials.length != 0
                                          // }
                                          placeholder='请输入主要疾病'
                                          onChange={() =>
                                            setIsDiseaseEmpty(false)
                                          }
                                          isTopLeft={true}
                                          onSelect={(disease) => {
                                            if (
                                              !selectedDiseasesZIFEI?.find(
                                                (d) => d?.icds === disease?.icds
                                              )
                                            ) {
                                              setSelectedDiseasesZIFEI(
                                                selectedDiseasesZIFEI.concat(
                                                  disease
                                                )
                                              )
                                              // diseasesChose(disease)
                                              const obj = {
                                                ...localObj,
                                                disease: selectedDiseasesZIFEI
                                                  .concat(disease)
                                                  .map(
                                                    (v: any) =>
                                                      `${v.name}/${v.icds}`
                                                  )
                                                  .join(','),
                                                selectedDiseasesZIFEI: selectedDiseasesZIFEI.concat(
                                                  disease
                                                ),
                                              }
                                              setLocalObj(obj)
                                              setPatientObj({
                                                ...patientObj,
                                                ...obj,
                                              })
                                              localStorage.setItem(
                                                'localObj',
                                                JSON.stringify(obj)
                                              )
                                              form.resetFields(['ZIFEIdisease'])
                                              // 如果有treatmentId跟registrationId,诊断修改时调取新接口去保存
                                              if(currenttreatmentId && registrationId){
                                                saveDisease(selectedDiseasesZIFEI
                                                  .concat(disease)
                                                  .map(
                                                    (v: any) =>
                                                      `${v.name}/${v.icds}`
                                                  )
                                                  .join(','))
                                              }
                                            }
                                          }}
                                          insuranceCode={
                                            insuranceItem?.insuranceCode
                                              ? insuranceItem?.insuranceCode
                                              : 'ZIFEI'
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </Form.Item>
                                </Col>
                                <Col
                                  flex={1}
                                  style={{
                                    marginLeft: '10px',
                                    // height: 'calc(100vh - 550px)',
                                    // overflowY: 'auto',
                                  }}
                                >
                                  <Row style={{ position: 'relative' }}>
                                    {!!selectedDiseasesZIFEI.length && (
                                      <Col
                                        flex='1'
                                        style={{
                                          borderRadius: 2,
                                          // padding: '10px 0 0 10px',
                                          marginBottom: 10,
                                        }}
                                      >
                                        {selectedDiseasesZIFEI.map((d) => (
                                          <div
                                            key={d.icds}
                                            className={styles.disease}
                                          >
                                            {`${d.name}/${d.icds}`}{' '}
                                            {/* {!isDiseaseEditable ||
                                            materials.length != 0 ? (
                                              ''
                                            ) : ( */}
                                              <CloseOutlined
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  setSelectedDiseasesZIFEI(
                                                    selectedDiseasesZIFEI.filter(
                                                      (i) => i?.icds !== d?.icds
                                                    )
                                                  )
                                                  const obj = {
                                                    ...localObj,
                                                    selectedDiseasesZIFEI: selectedDiseasesZIFEI.filter(
                                                      (i) => i?.icds !== d?.icds
                                                    ),
                                                  }
                                                  setLocalObj(obj)
                                                  setPatientObj(obj)
                                                  if(currenttreatmentId && registrationId){
                                                    const disease = selectedDiseasesZIFEI.filter(
                                                      (i) => i?.icds !== d?.icds
                                                    ) .map(
                                                      (v: any) =>
                                                        `${v.name}/${v.icds}`
                                                    )
                                                    .join(',')
                                                    saveDisease(disease)
                                                  }
                                                }}
                                              />
                                            {/* )} */}
                                          </div>
                                        ))}
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                              </Row>
                            </>
                          )}
                          {parintInfo &&
                            !!Object.keys(parintInfo).length &&
                            !messageFlag && (
                              <>
                                <Row
                                  style={{
                                    fontSize: 13,
                                    margin: '5px 0',
                                    border: '1px solid #d9d9d9',
                                    padding: '5px',
                                    marginLeft: '10px',
                                    height: '135px',
                                    overflowY: 'auto',
                                    backgroundColor: '#f5f5f5',
                                  }}
                                >

                                  {parintInfo.name} ,{parintInfo.sex} ,{' '}
                                  {parintInfo.age + '岁'} ,{' '}
                                  {parintInfo.treatmentStatusmc} ,{' '}
                                  {parintInfo.cbxzmc} ,{' '}
                                  {parintInfo.memberTypemc} ；
                                  {'医保余额：' + parintInfo.zhye}, {' '}
                                  {'当年余额：' + parintInfo.dnzhye} ,{' '}
                                  {'历年余额：' + parintInfo.lnzhye}；
                                  {'工作单位：' + parintInfo.brdw}

                                  <span>{searchMedicalList?.length
                                    ? '备案特慢病：'
                                    : ''}</span>
                                  <span
                                    style={{
                                      color: '#027AFF',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      if (disable || !searchMedicalList?.length) {
                                        return
                                      } else {
                                        setIsTipsModalVisible(true)
                                      }
                                    }}
                                  >
                                    {searchMedicalList?.length
                                    ? '点击引用'
                                    : ''} 
                                  </span>
                                  <span
                                    style={{
                                      color: '#027AFF',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                     setIsYBJRJSModalVisible(true)
                                    }}
                                  >
                                    {"今日结算"+(tradeCntInfo?.todayCnt || 0) +"次，本月结算"+(tradeCntInfo?.monthCnt || 0 )+"次"}
                                  </span>
                                </Row>
                                <Row
                                  style={{
                                    marginBottom: 5,
                                  }}
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      label='手机号'
                                      name='phone'
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^\d{3}-\d{8}|\d{4}-\d{7}|^(1[3,4,5,6,7,8,9][0-9]{9})$/
                                          ),
                                          message: '请输入正确的联系方式',
                                        },
                                      ]}
                                    >
                                      <Input
                                        maxLength={11}
                                        disabled={
                                          disable || materials.length != 0
                                        }
                                        onChange={(e) => {
                                          if (e.target.value && e.target.value.length == 11) {
                                            searchMember(e.target.value)
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item name='area' label='家庭地区'>
                                    <Cascaded
                                      disabled={
                                        disable || materials.length != 0
                                      }
                                      allowClear={false}
                                      // loadData={loadData}
                                      options={allList}
                                      placeholder='请选择'
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row
                                style={{
                                  marginTop: 5,
                                }}
                              >
                                <Col span={24}>
                                  <Form.Item
                                    {...{
                                      labelCol: { span: 6 },
                                      wrapperCol: { span: 18 },
                                    }}
                                    label='地址'
                                    name='address'
                                  >
                                    <Input
                                      placeholder='请输入'
                                      disabled={
                                        disable || materials.length != 0
                                      }
                                      maxLength={250}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                                <Row
                                  style={{
                                    marginTop: 5,
                                    marginBottom: 5,
                                  }}
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      label='科室'
                                      name='registrationDepartmentId'
                                      {...required}
                                    >
                                      <Select
                                        placeholder='请选择'
                                        disabled={
                                          disable || materials.length != 0
                                        }
                                        // suffixIcon={
                                        //   <CaretDownFilled
                                        //     style={{ color: theme.tc3 }}
                                        //   />
                                        // }
                                        onChange={(id: string) => {
                                          form.setFieldsValue({
                                            registrationDoctorId: undefined,
                                          })
                                          getDoctorList(id,credentials?.isAskMedicine)
                                          getMRTNKState(parintInfo)

                                          const department = departments?.find(
                                            (item: any) => item.id == id
                                          )
                                          const obj = {
                                            ...localObj,
                                            treatmentDepartmentId: id || undefined,
                                            treatmentDepartmentName: department?.name,
                                            treatmentDoctorId: undefined,
                                            treatmentDoctorName: undefined,
                                          }
                                          setLocalObj(obj)
                                          setPatientObj({ ...patientObj, ...obj })
                                          localStorage.setItem('localObj', JSON.stringify(obj))
                                        }}
                                      >
                                        {departments.map((d) => (
                                          <Select.Option
                                            key={d.id}
                                            value={d.id}
                                          >
                                            {d.name}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    marginBottom: 5,
                                  }}
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      label='医生'
                                      name='registrationDoctorId'
                                      {...required}
                                    >
                                      <Select
                                        placeholder='请选择'
                                        showSearch
                                        disabled={
                                          disable || materials.length != 0
                                        }
                                        // suffixIcon={
                                        //   <CaretDownFilled
                                        //     style={{ color: theme.tc3 }}
                                        //   />
                                        // }
                                        onChange={(id: string) => {
                                          const doctor = doctors?.find(
                                            (item: any) => item.id == id
                                          )
                                          const obj = {
                                            ...localObj,
                                            treatmentDoctorId: id || undefined,
                                            treatmentDoctorName: doctor?.name,
                                          }
                                          setLocalObj(obj)
                                          setPatientObj({ ...patientObj, ...obj })
                                          localStorage.setItem('localObj', JSON.stringify(obj))
                                        }}
                                        filterOption={(input, option) => {
                                          return option?.className
                                            ? ((option?.className as unknown) as string)
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            : false
                                        }}
                                      >
                                        {doctors?.map((d) => (
                                          <Select.Option
                                            className={d.mnemonicCode}
                                            key={d.id}
                                            value={d.id}
                                          >
                                            <span>{d.name} </span>
                                            {d?.lastRegTime ? <span>（</span> : ''}
                                            <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                                            {d?.lastRegTime ? <span>）</span> : ''}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                                {tenantCategory == 16 ?
                                  <Row
                                    style={{
                                      marginBottom: 5,
                                    }}
                                  >
                                    <Col span={24}>
                                      <Form.Item
                                        label='助理'
                                        name='treatmentAssistantDoctorId'
                                        {...{
                                          labelCol: { span: 6 },
                                          wrapperCol: { span: 18 },
                                        }}
                                      >
                                        <Select
                                          placeholder='请选择'
                                          showSearch
                                          allowClear
                                          disabled={
                                            disable || materials.length != 0
                                          }
                                          onChange={(id: string) => {
                                            if (!id) {
                                              setFlag(true)
                                            } else {
                                              setFlag(false)
                                            }
                                            const obj = {
                                              ...localObj,
                                              treatmentAssistantDoctorId: id,
                                              treatmentAssistantDoctorName: treatmentAssistantDoctorList?.filter(
                                                (v: any) => v.id == id
                                              )[0]?.realname,
                                            }
                                            setLocalObj(obj)
                                            setPatientObj({ ...patientObj, ...obj })
                                            localStorage.setItem(
                                              'localObj',
                                              JSON.stringify(obj)
                                            )
                                          }}
                                          filterOption={(input, option) => {
                                            return option?.className
                                              ? ((option?.className as unknown) as string)
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                              : false
                                          }}
                                        >
                                          {treatmentAssistantDoctorList?.map((d) => (
                                            <Select.Option
                                              className={d.mnemonicCode}
                                              key={d.id}
                                              value={d.id}
                                            >
                                              <span>{d.realname}</span>
                                              {d?.lastRegTime ? <span>（</span> : ''}
                                              <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                                              {d?.lastRegTime ? <span>）</span> : ''}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row> :
                                  <></>}
                                <Row
                                  gutter={6}
                                  style={{
                                    marginBottom: 0,
                                  }}
                                >
                                  <Col span={16}>
                                    <Form.Item
                                      label='诊断'
                                      name='disease'
                                      required
                                      {...{
                                        labelCol: { span: 9 },
                                        wrapperCol: { span: 15 },
                                      }}
                                      rules={[
                                        {
                                          max: 500,
                                          message: '最长500位!',
                                        },
                                        () => ({
                                          validator: () => {
                                            if (isDiseaseEmpty) {
                                              return Promise.reject(
                                                '请输入主要疾病'
                                              )
                                            }
                                            return Promise.resolve()
                                          },
                                        }),
                                      ]}
                                    >
                                      <Row
                                        wrap={false}
                                        style={{ height: '40px' }}
                                        gutter={10}
                                      >
                                        <Col span={24}>
                                          <DiseaseInput
                                            isAskMedicine={credentials?.isAskMedicine || 0}
                                            isMedical={1}
                                            autoFocus={
                                              selectedDiseases?.length
                                                ? true
                                                : false
                                            }
                                            // disabled={
                                            //   !isDiseaseEditable ||
                                            //   disable ||
                                            //   materials.length != 0
                                            // }
                                            placeholder='主要疾病'
                                            isTopLeft={true}
                                            onChange={() =>
                                              setIsDiseaseEmpty(false)
                                            }
                                            onSelect={(disease) => {
                                              if (
                                                !selectedDiseases.find(
                                                  (d) =>
                                                    d?.icds === disease?.icds
                                                )
                                              ) {
                                                setSelectedDiseases(
                                                  selectedDiseases.concat(
                                                    disease
                                                  )
                                                )
                                                const obj = {
                                                  ...localObj,
                                                  disease: selectedDiseasesZIFEI
                                                    .concat(disease)
                                                    .map(
                                                      (v: any) =>
                                                        `${v.name}/${v.icds}`
                                                    )
                                                    .join(','),
                                                  selectedDiseasesZIFEI: selectedDiseasesZIFEI.concat(
                                                    disease
                                                  ),
                                                }
                                                setLocalObj(obj)
                                                setPatientObj({
                                                  ...patientObj,
                                                  ...obj,
                                                })
                                                localStorage.setItem(
                                                  'localObj',
                                                  JSON.stringify(obj)
                                                )
                                                diseasesChose(disease)
                                                form.resetFields(['disease'])
                                                if(currenttreatmentId && registrationId){
                                                  saveDisease(selectedDiseases
                                                    .concat(disease)
                                                    .map(
                                                      (v: any) =>
                                                        `${v.name}/${v.icds}`
                                                    )
                                                    .join(','))
                                                }
                                              }
                                            }}
                                            insuranceCode={
                                              insuranceItem?.insuranceCode
                                                ? insuranceItem?.insuranceCode
                                                : 'ZIFEI'
                                            }
                                          />
                                        </Col>
                                      </Row>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    {/* <Row
                                      style={{
                                        marginBottom: 20
                                      }}>
                                      <Col span={24}> */}
                                    <Form.Item
                                      // label='就诊类型'
                                      {...{
                                        labelCol: { span: 0 },
                                        wrapperCol: { span: 24 },
                                      }}
                                      name='treatmentCategory'
                                      // name={['disease', 'treatmentCategory']}
                                    >
                                      <Select
                                        // onSelect={(values: number) => {
                                        //   treatmentCategoryChose(values as number)
                                        // }}
                                        disabled={materials.length != 0}
                                      >
                                        {insuranceItem?.insuranceCode ===
                                          'CHONGQING' &&
                                          TreatmentCategoriesCQ.map((c) => (
                                            <Select.Option key={c} value={c}>
                                              {getTreatmentCategoryName(c)}
                                            </Select.Option>
                                          ))}
                                        {insuranceItem?.insuranceCode ===
                                          'ZHEJIANG' &&
                                          TreatmentCategories.map((c) => (
                                            <Select.Option key={c} value={c}>
                                              {getTreatmentCategoryName(c)}
                                            </Select.Option>
                                          ))}
                                        {insuranceItem?.insuranceCode ===
                                          'JIANGSU' &&
                                          TreatmentCategoriesJS.map((c) => (
                                            <Select.Option key={c} value={c}>
                                              {getTreatmentCategoryName(c)}
                                            </Select.Option>
                                          ))}
                                        {(insuranceItem?.insuranceCode ===
                                          'ZIFEI' ||
                                          treatment?.insuranceCode ===
                                            'ZIFEI') &&
                                          TreatmentCategoriesZF.map((c) => (
                                            <Select.Option key={c} value={c}>
                                              {getTreatmentCategoryName(c)}
                                            </Select.Option>
                                          ))}
                                      </Select>
                                    </Form.Item>
                                    {/* </Col>
                                    </Row> */}
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    marginBottom: 0,
                                  }}
                                >
                                  <Col span={24}>
                                    <Row
                                      style={{
                                        position: 'relative',
                                        // height: 'calc(100vh - 575px)',
                                        // overflowY: 'auto',
                                      }}
                                    >
                                      {!!selectedDiseases.length && (
                                        <Col
                                          flex='1'
                                          style={{
                                            borderRadius: 2,
                                            // padding: '10px 0 0 10px',
                                            marginBottom: 0,
                                          }}
                                          className={styles.diseasesList}
                                        >
                                          {selectedDiseases.map((d) => (
                                            <div
                                              key={d.icds}
                                              className={styles.disease}
                                            >
                                              {`${d.name}/${d.icds}`}{' '}
                                              {/* {!isDiseaseEditable ||
                                              disable ||
                                              materials.length != 0 ? (
                                                ''
                                              ) : ( */}
                                                <CloseOutlined
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => {
                                                    setSelectedDiseases(
                                                      selectedDiseases.filter(
                                                        (i) =>
                                                          i?.icds !== d?.icds
                                                      )
                                                    )
                                                    if(currenttreatmentId && registrationId){
                                                      const disease = selectedDiseases.filter(
                                                        (i) => i?.icds !== d?.icds
                                                      ) .map(
                                                        (v: any) =>
                                                          `${v.name}/${v.icds}`
                                                      )
                                                      .join(',')
                                                      saveDisease(disease)
                                                    }
                                                  }}
                                                />
                                              {/* )} */}
                                            </div>
                                          ))}
                                        </Col>
                                      )}
                                    </Row>
                                  </Col>
                                </Row>
                                {isHisCode && (
                                  <Row
                                    justify='end'
                                    style={{
                                      width:'230px',
                                      position: 'fixed',
                                      bottom: 20,
                                      // right: 0,
                                    }}
                                  >
                                    <Col>
                                      <Button
                                        type='primary'
                                        style={{ marginLeft: 10 }}
                                        loading={btnLoading}
                                        onClick={() => {
                                          if (
                                            !Object.keys(parintInfo).length &&
                                            value != 0
                                          ) {
                                            notification.info({
                                              message: '请先读卡',
                                            })
                                          } else {
                                            form.submit()
                                          }
                                        }}
                                        disabled={disable}
                                      >
                                        保存患者
                                      </Button>
                                    </Col>
                                  </Row>
                                )}
                              </>
                            )}
                          {/* 隐藏域 */}
                          <div style={{ display: 'none' }}>
                            <Row
                              style={{ marginLeft: 5, marginRight: 20 }}
                              className={styles.formItem}
                            >
                              <Col span={16} order={1}>
                                <Form.Item
                                  required
                                  label='患者姓名'
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'nowrap',
                                  }}
                                >
                                  <Row wrap={false}>
                                    <Form.Item
                                      noStyle
                                      name='name'
                                      rules={[
                                        {
                                          required: true,
                                          max: 40,
                                          message: '请输入患者姓名',
                                        },
                                      ]}
                                    >
                                      <Input />
                                    </Form.Item>
                                  </Row>
                                </Form.Item>
                              </Col>
                              <Col span={8} order={3}>
                                <Form.Item
                                  label='年龄'
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'nowrap',
                                  }}
                                  required
                                >
                                  <Row
                                    wrap={false}
                                    align='middle'
                                    style={{ height: '50px' }}
                                  >
                                    <Form.Item
                                      key={`age-first2-${ageUnit}`}
                                      name={ageUnit === 'month' ? 'ageMonth' : 'ageYear'}
                                      noStyle
                                      dependencies={ageUnit === 'month' ? ['ageDay'] : ['ageMonth']}
                                      rules={[

                                        {
                                          pattern: ageUnit === 'month' ? /^\d{0,2}$/ : /^(200|[01]?[0-9]{1,2})$/,
                                            message: '请输入正确的年龄',
                                          },
                                          ({ getFieldValue }) => ({
                                            validator: (_, value) => {
                                              const secondField = ageUnit === 'month' ? getFieldValue('ageDay') : getFieldValue('ageMonth')
                                              if ((!value && value !== 0) && (!secondField && secondField !== 0)) {
                                                return Promise.reject(
                                                  new Error('请输入正确的年龄')
                                                )
                                              }
                                              return Promise.resolve()
                                            },
                                          }),
                                        ]}
                                      >
                                        <Input
                                          readOnly={hasCard}
                                          style={{ maxWidth: '3rem' }}
                                        />
                                    </Form.Item>
                                    <Dropdown
                                      trigger={['click']}
                                      overlay={
                                        <Menu
                                          selectedKeys={[ageUnit]}
                                          onClick={({ key }) => {
                                            if (key !== ageUnit) {
                                              const newUnit = key as 'year' | 'month'
                                              const rawFirst = form.getFieldValue(ageUnit === 'month' ? 'ageMonth' : 'ageYear')
                                              const rawSecond = form.getFieldValue(ageUnit === 'month' ? 'ageDay' : 'ageMonth')
                                              if (newUnit === 'month') {
                                                form.setFieldsValue({ ageMonth: rawFirst, ageDay: rawSecond })
                                                setAgeUnit('month')
                                                const months = parseInt(rawFirst) || 0
                                                const days = parseInt(rawSecond) || 0
                                                if (months || days) {
                                                  form.setFieldsValue({ birthday: moment().subtract(months, 'months').subtract(days, 'days').format('YYYY/MM/DD') })
                                                }
                                                setTimeout(() => {
                                                  if (rawFirst || rawSecond) {
                                                    form.validateFields(['ageMonth', 'ageDay'])
                                                  }
                                                }, 100)
                                              } else {
                                                form.setFieldsValue({ ageYear: rawFirst, ageMonth: rawSecond })
                                                setAgeUnit('year')
                                                const years = parseInt(rawFirst) || 0
                                                const months = parseInt(rawSecond) || 0
                                                if (years || months) {
                                                  form.setFieldsValue({ birthday: moment().subtract(years, 'years').subtract(months, 'months').format('YYYY/MM/DD') })
                                                }
                                                setTimeout(() => {
                                                  if (rawFirst || rawSecond) {
                                                    form.validateFields(['ageYear', 'ageMonth'])
                                                  }
                                                }, 100)
                                              }
                                            }
                                          }}
                                          style={{ minWidth: 50 }}
                                        >
                                          <Menu.Item key="year">岁</Menu.Item>
                                          <Menu.Item key="month">月</Menu.Item>
                                        </Menu>
                                      }
                                    >
                                      <div
                                        style={{
                                          color: theme.tc2,
                                          fontSize: '1rem',
                                          margin: '0 6px',
                                          cursor: 'pointer',
                                          userSelect: 'none',
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {ageUnit === 'year' ? '岁' : '月'}
                                        <CaretDownFilled style={{ fontSize: '0.7rem', marginLeft: 2 }} />
                                      </div>
                                    </Dropdown>
                                    <Form.Item
                                      key={`age-second2-${ageUnit}`}
                                      name={ageUnit === 'month' ? 'ageDay' : 'ageMonth'}
                                      noStyle
                                      dependencies={ageUnit === 'month' ? ['ageMonth'] : ['ageYear']}
                                      rules={[
                                        ageUnit === 'month'
                                          ? { pattern: /^\d{0,2}$/, message: '请输入正确的天数' }
                                          : { pattern: /^(0?[0-9]|1[0-1])$/, message: '请输入正确的月份' },
                                      ]}
                                    >
                                      <Input
                                        readOnly={hasCard}
                                        style={{ maxWidth: '3rem' }}
                                      />
                                    </Form.Item>
                                    <div
                                      style={{
                                        color: theme.tc2,
                                        fontSize: '1rem',
                                          margin: '0 6px',
                                        }}
                                      >
                                        {ageUnit === 'year' ? '月' : '天'}
                                      </div>
                                      <Form.Item
                                        name='birthday'
                                        noStyle
                                        style={{ flex: 1 }}
                                        rules={[
                                          { max: 10, message: '最多10个字' },
                                          () => ({
                                            validator(_, value) {
                                              if (!value) return Promise.resolve()
                                              const str = String(value)
                                              if (!/^(?:1\d{3}|2\d{3})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})\/(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12]\d|3[01])|(?:1\d{3}|2\d{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/.test(str)) {
                                                return Promise.reject(new Error('格式参考:19980808'))
                                              }
                                              const digits = str.replace(/[-/]/g, '')
                                              const now = new Date()
                                              const todayStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`
                                              if (digits > todayStr) {
                                                form.setFieldsValue({
                                                  ageYear: '',
                                                  age: '',
                                                  ageMonth: '',
                                                  ageDay: '',
                                                })
                                                return Promise.reject(new Error('出生日期填写不对'))
                                              }
                                              return Promise.resolve()
                                            },
                                          }),
                                        ]}
                                      >
                                        <Input readOnly={hasCard} />
                                      </Form.Item>
                                  </Row>
                                </Form.Item>
                              </Col>
                              <Col span={8} order={2}>
                                <Form.Item
                                  {...required}
                                  label='性别'
                                  name='sex'
                                  className={styles.normal}
                                >
                                  <Radio.Group disabled={hasCard}>
                                    {[
                                      Gender.Male,
                                      Gender.Female,
                                      Gender.Unknown,
                                    ].map((g) => (
                                      <Radio key={g} value={g}>
                                        {getGenderName(g)}
                                      </Radio>
                                    ))}
                                  </Radio.Group>
                                </Form.Item>
                              </Col>
                              {/* </Row>
                              <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}> */}
                              <Col span={8} order={4}>
                                <Form.Item
                                  label='身份证号'
                                  name='idCardNumber'
                                  rules={idCardRules}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col span={8} order={5}>
                                <Form.Item
                                  label='工作单位'
                                  name='companyName'
                                  rules={[
                                    {
                                      max: 120,
                                      message: '最长120位!',
                                    },
                                  ]}
                                >
                                  <Input readOnly={hasCard} />
                                </Form.Item>
                              </Col>
                              {/* </Row>
                              <Row gutter={formGutter} style={{ marginLeft: 5, marginRight: 20 }}> */}
                              <Col span={16} order={7}>
                                <Form.Item
                                  label='地址'
                                  name='address'
                                  rules={[
                                    {
                                      max: 250,
                                      message: '最长250位!',
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Col span={8}>
                              <Form.Item name='cbxzmc' label='险种类别'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='memberTypemc' label='人员类别'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                name='treatmentStatusmc'
                                label='参保状态'
                              >
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='zhye' label='账户余额'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='dnzhye' label='当年余额'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='lnzhye' label='历年余额'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='ybkh' label='医保卡号'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item name='ybPersonalNo' label='个人编号'>
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                          </div>
                        </div>
                      </Form>
                      </div>
                    </div>
                    <div className={styles.disableModalContainer}>
                      {/* !disable && value != 0 */}
                      {!disable && value != 0 && (
                        <div
                          className={styles.disableModal}
                          onClick={() => {
                            notification.info({
                              message: isHisCode
                                ? '请先保存医保患者信息'
                                : '请先保存自费患者信息',
                            })
                          }}
                        ></div>
                      )}
                      <Tabs
                        tabPosition='bottom'
                        activeKey={
                          (category === RecipeCategory.Medicine)
                            ? '0'
                            : category === RecipeCategory.Tcm
                            ? '1'
                            : category === RecipeCategory.Dispose ?
                            '2'
                            :'0'
                        }
                        onChange={(key) => {
                          if (materials.length != 0) {
                            notification.error({
                              message: '请先结算或清空药品!',
                            })
                            return
                          }
                          if (key === '0') {
                            setCategory(RecipeCategory.Medicine)
                          } else if (key === '1') {
                            setCategory(RecipeCategory.Tcm)
                          } else if (key === '2') {
                            setCategory(RecipeCategory.Dispose)
                          }
                        }}
                        className={styles.tabs}
                      >
                        <TabPane key='0' tab={tenantCategory == 16 ?'治疗' :'西药'} />
                        {hisVersion == 0 && tenantCategory != 16 ? (
                          <TabPane key='1' tab='中药' />
                        ) : (
                          <></>
                        )}
                        {tenantCategory != 16 && (
                          <TabPane key='2' tab='处置' />
                        )}
                      </Tabs>
                      <div
                        style={{
                          height: 'calc(100% - 117px)',
                          overflow: 'auto',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          // paddingBottom: '10px'
                        }}
                      >
                        <RecipeEditor
                          // 中药帖数
                          tipCountNum={(v) => {
                            setTipsCount(v)
                          }}
                          name={form.getFieldValue('registrationCategory') == 0 ? form.getFieldValue('name') : parintInfo?.name}
                          kskdTag={true}
                          isMember={membersInfo?.memberPhone ? true : false}
                          state={!isHisCode ? 1 : ''} //快速开单
                          discountFlag={1} //医保自费折扣标志
                          insuranceCode={
                            patientData?.registration.insuranceCode || (form.getFieldValue('registrationCategory') == 0 ? insuranceArray?.[0]?.insuranceCode || 'ZIFEI' : insuranceArray?.[0]?.insuranceCode )
                          }
                          patientObj={patientObj}
                          patientId={currentPatientId || patientObj?.patientId}
                          style={{
                            flex: 1,
                            margin: '0 10px',
                            // paddingBottom: 55,
                          }}
                          isInsurance={!isInsurance} // 判断药品零售 是否为医保
                          treatmentId={
                            recipes.length > 0
                              ? recipes[0].treatmentId
                              : currenttreatmentId
                              ? currenttreatmentId.toString()
                              : undefined
                          }
                          recipeId={
                            recipes.find((r) => r.category === category)?.id
                          }
                          isCoupons={true}
                          recipeCategory={category}
                          mode={RecipeEditorMode.Retail}
                          onNewRecipe={(recipe:any, copyDiease) => {
                            setPatientBtn(!patientObj ? true : false) //完善病历弹窗先后顺序
                            dispatch(setTreatmentId(recipe.treatmentId))
                            setregistrationId(recipe.registrationId)
                            setcurrenttreatmentId(recipe.treatmentId)
                            const find = recipes.find((r) => r.id === recipe.id)
                            if (copyDiease) {
                              const copy = copyDiease
                                ?.split(',')
                                .map((v: any) => {
                                  const disease: any = v?.split('/')
                                  return { name: disease[0], icds: disease[1] }
                                })
                              setSelectedDiseasesZIFEI(copy)
                            }
                            if (find) {
                              setRecipes(
                                recipes.map((r) =>
                                  r.id === recipe.id ? recipe : r
                                )
                              )
                            } else {
                              setRecipes(recipes.concat(recipe))
                            }
                            const flag = localStorage.getItem('SHOWJGMODAL')
                            if (flag == '1') {
                              return
                            } else {
                              if (
                                tenantCountyCode?.indexOf('3205') == 0 &&
                                (value != 0
                                  ? !form.getFieldValue('registrationDoctorId')
                                  : !patientObj?.treatmentDoctorId)
                              ) {
                                setIsTipsVisible(true)
                              }
                            }
                          }}
                        />
                      </div>
                      {/* <Row style={{ height: '10px', backgroundColor: '#f1f1f1' }}></Row> */}
                      <Row
                        align='middle'
                        justify='end'
                        style={{
                          height: '50px',
                          padding: '0 20px',
                          marginTop: '10px',
                          backgroundColor: theme.pn,
                          borderRadius: '8px',
                        }}
                      >
                        <Col span={12} style={{overflow:"hidden",whiteSpace:"nowrap"}}>
                          <Popover
                            placement='topLeft'
                            content={
                              <div>
                                {notice && notice.recentlyTreatmentTime && (
                                  <div
                                    style={{
                                      fontSize: '1rem',
                                      color: theme.e,
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    最近就诊：
                                    {moment(notice.recentlyTreatmentTime).format(
                                      'YYYY/MM/DD'
                                    )}
                                    <Tooltip title={notice?.disease}>
                                      <span
                                        style={{
                                          marginLeft: 15,
                                          maxWidth: 400,
                                          overflow: 'hidden',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        疾病名称：{notice?.disease}
                                      </span>
                                    </Tooltip>
                                  </div>
                                )}
                                <div style={{ display: 'inline-grid' }}>
                                  <span
                                    style={{
                                      marginTop: '10px',
                                      color: 'rgba(158,158,164,0.84)',
                                      fontSize: '14px',
                                      fontWeight: 'bold',
                                    }}
                                >
                                  以下是
                                  { form.getFieldValue('registrationCategory') != 0? '医保' : '自费' }
                                  智能提醒内容，供您参考：
                                </span>
                                  {recipesMemo?.map((v: any, i: number) => {
                                    return (
                                      <div
                                        key={i}
                                        style={{ marginTop: '10px', width: '700px' }}
                                      >
                                      <span
                                        style={{
                                          color: 'rgb(77,72,206)',
                                          fontSize: '1rem',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {i + 1}. {v?.name}
                                      </span>
                                        <span
                                          style={{ marginLeft: '10px', fontSize: '14px' }}>
                                        {v?.memo}
                                      </span>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            }
                            trigger='click'
                          >
                            <div style={{ cursor: 'pointer', marginLeft: '15px' }}>
                              <div>
                                {recipesMemo?.length ? (
                                  <div
                                    className={`${styles.carouselDiv} ${isAnimating ? styles.fadeIn : ''
                                      }`}
                                  >
                                    <span
                                      style={{
                                        color: 'rgb(77,72,206)',
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {showMemoStruct?.name}
                                    </span>
                                    <span style={{ marginLeft: '10px', fontSize: '14px' }}>
                                      {showMemoStruct?.memo}
                                    </span>
                                  </div>
                                ) : (
                                  notice &&
                                  notice.recentlyTreatmentTime && (
                                    <div
                                      style={{
                                        fontSize: '1rem',
                                        color: theme.e,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      最近就诊：
                                      {moment(notice.recentlyTreatmentTime).format(
                                        'YYYY/MM/DD'
                                      )}
                                      <Tooltip title={notice?.disease}>
                                        <span
                                          style={{
                                            marginLeft: 15,
                                            maxWidth: 400,
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          疾病名称：{notice?.disease}
                                        </span>
                                      </Tooltip>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </Popover>
                        </Col  >
                        <Col span={12} style={{display:"flex",justifyContent:"flex-end"}} >
                        {JSON.stringify(insuranceItem) !== '{}' && (
                          <>
                            {
                              patientInsurance?.insuranceCode &&
                              patientInsurance?.insuranceCode == 'ZHEJIANG' &&(
                                <Button
                                  disabled={searchPsnSumDisabled}
                                  type='link'
                                  onClick={() => {
                                    if (patientInsurance?.ybPersonalNo) {
                                      setIsMedicationAdministrationRecordVisible(true)
                                    } else {
                                      notification.warn({
                                        message: '查询不到该患者的医保信息',
                                        duration: 1.5,
                                      })
                                    }
                                  }}
                                >
                                  90天就诊记录
                                </Button>
                              )
                            }
                            <Button
                            disabled={searchPsnSumDisabled}
                            type='link'
                            onClick={() => {
                              if (patientInsurance?.ybPersonalNo) {
                                setSearchPsnSumDisabled(true)
                                //如果联通医保，则查询最新的
                                // if (pingState) {
                                searchPsnSum(
                                  true,
                                  'requestString',
                                  patientInsurance.ybPersonalNo,
                                  patientInsurance?.insuranceRegion
                                )
                                // } else {
                                //   //否则查询本地数据库的
                                //   // dispatch(searchPsnSumForLocalAsync({
                                //   dispatch(
                                //     searchPsnSumForLocalAsync({
                                //       psnNo: patientInsurance.ybPersonalNo,
                                //     })
                                //   )
                                //     .then(unwrapResult)
                                //     .then((res) => {
                                //       setSumVisible(true)
                                //       setSumList(res)
                                //       setSearchPsnSumDisabled(false)
                                //     })
                                //     .catch((ex) => {
                                //       setSearchPsnSumDisabled(false)
                                //     })
                                // }
                              } else {
                                notification.warn({
                                  message: '查询不到该患者的医保信息',
                                  duration: 1.5,
                                })
                              }
                            }}
                          >
                            查询患者医保账户累计
                            </Button>

                            <Button
                              style={{marginRight : '10px'}}
                              type='primary'
                              // disabled={!treatment?.id}
                              onClick={async () => {
                                beforeAlert('requestString')
                                setIsShowBeforeAlert(true)
                              }}
                            >
                              查询医保事前提醒
                            </Button>
                          </>
                        )}
                        {!isAskMedicine && (
                          <Button
                            type='primary'
                            loading={loading}
                            disabled={!recipes.filter(isRecipePayable).length}
                            onClick={() => {
                              const runButtonLogic = () => {
                              localStorage?.setItem(
                                'editMedicalVisible',
                                'false'
                              )
                              if (!tipsCount) {
                                notification.info({
                                  message: '请输入正确的帖数。',
                                })
                              } else {
                                if (!isInsurance) {
                                  submit(recipes) // 自费
                                } else {
                                  // 医保
                                  if (treatment) {
                                    dispatch(checkTreatmentAsync(treatment.id))
                                      .then(unwrapResult)
                                      .then(() => {
                                        //医保开启了自动提醒
                                        if (settings?.[SettingChecks.YBSQZDTX]) {
                                          setIsAutoRemind(true)
                                          beforeAlert('requestString','',true)
                                        } else {
                                          gotoPayment()
                                        }
                                      })
                                  }
                                }
                              }
                              }
                              checkOverOnlineLimit(runButtonLogic)
                            }}
                          >
                            预结算(空格)
                          </Button>
                        )}
                        {isAskMedicine && (
                          <Button
                            type='primary'
                            loading={loading}
                            style={{ marginLeft: '10px' }}
                            disabled={
                              !recipes.filter(isRecipePayable).length ||
                              !(recipes.length > 0
                                ? recipes[0].treatmentId
                                : currenttreatmentId
                                ? currenttreatmentId.toString()
                                : undefined)
                            }
                            onClick={() => {
                              setIsModalVisible(true)
                             
                            }}
                          >
                            处方申请
                          </Button>
                        )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ) : v?.name == '收费明细' ? (
                  <RetailList
                    goBackParams={(v) => {
                      setNotice(undefined)
                      const diseaseList = v?.disease ? v?.disease
                      ?.split(',')
                      ?.map((d: any) => d?.split('/'))
                      ?.map(
                        (pair: any) =>
                          ({ name: pair[0], icds: pair[1] } as Disease)
                      ) : []
                      dispatch(setTreatmentId(v.treatmentId))
                      setregistrationId(v.registrationId)
                      setcurrenttreatmentId(v.treatmentId)
                      if(v?.patientId && v?.patientId != -1){
                        getNotice(v?.patientId)
                      }
                      if (v && v.insuranceCode && v.insuranceCode != 'ZIFEI') {
                        // setMessageFlag(true)
                        setIsInsurance(true)
                        setInsuranceItem(insuranceArray?.[0])
                        setPatientInsurance({
                          ybPersonalNo: v?.ybPersonalNo,
                          name: v?.name,
                          dnzhye: v?.dnzhye,
                          lnzhye: v?.lnzhye,
                          companyName: v?.companyName,
                          memberTypeStr: v?.memberTypeStr,
                          insuranceRegion: v?.insuranceRegion,
                          insuranceCode: v?.insuranceCode,
                        })
                        
                        setParintInfo({
                          ...v.patientInsurance,
                          age: calculateAge(v?.patientInsurance.birthday),
                          name: v?.patientInsurance.name,
                          address: v?.patientInsurance?.address || v?.patientInsurance?.companyName,
                          provinceCode: v?.patientInsurance?.provinceCode,
                          cityCode: v?.patientInsurance?.cityCode,
                          contryCode: v?.patientInsurance?.contryCode,
                          idCardNumber: v?.patientInsurance.idCard,
                          cbxzmc: v?.patientInsurance.cbxzmc, //险种类别
                          memberTypemc: v?.patientInsurance.memberTypemc, // 人员类别
                          treatmentStatusmc:
                            v?.patientInsurance.treatmentStatusmc, //参保状态
                          dnzhye: v?.patientInsurance.dnzhye, //当年余额
                          lnzhye: v?.patientInsurance.lnzhye, // 历年余额
                          sex: getGenderName(Number(v?.patientInsurance.sex)),
                          ageYear: calculateAge(v?.patientInsurance.birthday),
                        })
                        setTradeCntInfo(v?.cntBean);
                        // setValue(insuranceArray?.[0])
                        setSelectedDiseases(diseaseList)
                        setDiabled(true)
                        setDisable(true)
                        // setIsHisCode(true)
                      } else {
                        setMessageFlag(false)
                        setIsInsurance(false)
                        setInsuranceItem({})
                        setParintInfo({})
                        setTradeCntInfo({})
                        setIsHisCode(false)
                        setValue(0)
                      }
                      setKeyword(v?.patientName)
                      const isInsAgeBothZero = Number(v?.ageYear) === 0 && Number(v?.ageMonth) === 0
                      form.setFieldsValue({
                        name: v?.patientName,
                        ageMonth: isInsAgeBothZero ? '' : v?.ageMonth,
                        ageYear: isInsAgeBothZero ? '' : v?.ageYear,
                        ageDay: v?.ageDay,
                        birthday: v?.birthday
                          ? moment(v.birthday).format(DateTimeFormatSimple)
                          : '',
                        patientId: v?.patientId,
                        patientName: v?.patientName,
                        sex: v?.patientSex,
                        phone: v?.phone ? (!KSKDCKHRSJHData ? getMaskPhone(decrypt(v.phone)) : decrypt(v.phone)) : undefined,
                        address: v?.address,
                        area: v?.provinceCode && v?.provinceCode != 0
                        ? [
                          Number(v?.provinceCode),
                          Number(v?.cityCode),
                          Number(v?.contryCode),
                        ] : [],
                        treatmentNo: v?.treatmentNo,
                        registrationDepartmentId:
                        v?.treatmentDepartmentId || '',
                        registrationDoctorId: v?.treatmentDoctorId || '',
                        ZIFEIregistrationDepartmentId:
                          v?.treatmentDepartmentId || '',
                        treatmentAssistantDoctorId: v?.treatmentAssistantDoctorId != -1 ? v?.treatmentAssistantDoctorId || '' : '',
                        ZIFEIregistrationDoctorId: v?.treatmentDoctorId || '',
                        registrationCategory:
                          v?.insuranceCode == 'ZIFEI'
                            ? RegistrationCategory.SelfPay
                            : insuranceArray?.[0],
                      })
                      if (v?.birthday) {
                        updateYearsAndMonths()
                      }
                      // 加载对应科室的医生列表，否则医生 Select 无法显示医生姓名
                      if (v?.treatmentDepartmentId) {
                        getDoctorList(v?.treatmentDepartmentId, credentials?.isAskMedicine)
                      }
                      localStorage.setItem('localObj', JSON.stringify(v))
                      setcfsqjlFlag(true)
                      const data = {...v, provinceCode: v?.provinceCode,cityCode: v?.cityCode,contryCode:v?.contryCode}
                      setLocalObj({ ...data })
                      setPatientObj({ ...data })
                      setSelectedDiseasesZIFEI(diseaseList)
                    }}
                  />
                ) : (
                  <></>
                )}
              </TabPane>
            </>
          )
        })}
        {/* {(JuheShow?.openHubPay == 1 ||
          JuheShow?.openHubPayJiali == 1 ||
          JuheShow?.openHubPayYinlian == 1 ||
          JuheShow?.openHubPayKanglin == 1) && (
          <TabPane key='2' tab='聚合支付记录'>
            <JuheRetailList />
          </TabPane>
        )} */}
      </TabBar>

      <div
        style={{
          display: 'flex',
          position: 'absolute',
          top: '13px',
          right: '34px',
        }}
      >
        <Row
          style={{
            height: '2.2rem',
            fontSize: '1rem',
            padding: '0 20px',
          }}
          align='middle'
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#027AFF',
            }}
          >
            <SettingOutlined
              style={{
                fontSize: '20px',
                color: '#027AFF',
              }}
            />
            <a
              type='text'
              style={{
                marginLeft: '6px',
                fontSize: '16px',
                color: '#027AFF',
              }}
              onClick={() => {
                setIsRetailPreferencesSettingVisible(true)
              }}
            >
              偏好设置
            </a>
          </div>
        </Row>
        <Button
          type='primary'
          onClick={() => {
            switch (searchMembersBtnText) {
              case 0:
                setSearchMembersModalVisible(true)
                break
              case 1:
                setSearchMembersBtnText(2)
                break
              case 2:
                setSearchMembersBtnText(1)
                break
            }
          }}
        >
          {searchMembersBtnText == 0
            ? '会员卡'
            : searchMembersBtnText == 1
            ? '隐藏会员信息'
            : '查看会员信息'}
        </Button>
        {searchMembersBtnText == 1 && (
          <div className={styles.membersInfoWrap}>
            <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
              <span>会员：{membersInfo?.memberName}</span>
              <span>{membersInfo?.memberPhone ? (!KSKDCKHRSJHData ? getMaskPhone(membersInfo?.memberPhone) : membersInfo?.memberPhone) : ''}</span>
              <span>余额：{membersInfo?.balanceMoney?.toFixed(2)}</span>
              <Button
                size='small'
                type='primary'
                onClick={() => {
                  setSearchMembersBtnText(0)
                  if (patientObj?.patientId && patientObj?.patientId == membersInfo?.patient?.id && patientAutoFilled.current) {
                    setMembersInfo({})
                    if (isHisCode) {
                      clearYBForm()
                    } else {
                      clearZifeiForm()
                    }
                  } else {
                    setMembersInfo({})
                  }
                  notification.success({ message: '登出成功' })
                }}
              >
                退出
              </Button>
            </div>
          </div>
        )}
      </div>
      {/* {currentTab === '0' && (
        <Row
          align='middle'
          justify='space-between'
          style={{
            flexBasis: '3.125rem',
            padding: '0 20px',
            backgroundColor: theme.pn,
          }}
        >
          <Row></Row>
          <Button
            type='primary'
            loading={loading}
            disabled={!recipes.filter(isRecipePayable).length}
            onClick={() => {
              localStorage?.setItem('editMedicalVisible', 'false')
              if (!tipsCount) {
                notification.info({
                  message: '请输入正确的帖数。',
                })
              } else {
                if (!isInsurance) {
                  submit(recipes) // 自费
                } else {
                  // 医保
                  if (treatment) {
                    dispatch(checkTreatmentAsync(treatment.id))
                      .then(unwrapResult)
                      .then(() => {
                        gotoPayment()
                      })
                  }
                }
              }
            }}
          >
            预结算(空格)
          </Button>
        </Row>
      )} */}
      <PatientModal
        CKHZSJHData={KSKDCKHRSJHData} //快速开单管理
        patient={patientObj}
        visible={patientModalVisible}
        status={1}
        onCancel={() => {
          setPatientModalVisible(false)
        }}
        onRetailFn={(data) => {
          setPatientModalVisible(false)
          setPatientObj({
            ...patientObj,
            ...data,
          })
        }}
      ></PatientModal>
      <SearchMembersModal
        visible={searchMembersModalVisible}
        onCancel={() => setSearchMembersModalVisible(false)}
        onOk={(data) => {
          setSearchMembersModalVisible(false)
          setSearchMembersBtnText(1)
          notification.success({ message: '查询成功' })
          setMembersInfo(data)
        }}
        openFn={() => {
          setSearchMembersBtnText(0)
          setAddMembersVisible(true)
          setSearchMembersModalVisible(false)
        }}
      />

      <AddMembersModal
        visible={addMembersVisible}
        btnType={addBtnType}
        onCancel={() => setAddMembersVisible(false)}
        onOk={(data) => {
          dispatch(getAddMembers(data))
            .then(unwrapResult)
            .then(() => {
              notification.success({ message: '新增成功' })
            })
            .finally(() => {
              setAddBtnType(!addBtnType)
              // setAddMembersVisible(false)
            })
        }}
      />

      <RetailPreferencesSettingModal
        visible={isRetailPreferencesSettingVisible}
        onOk={() => {
          setIsRetailPreferencesSettingVisible(false)
        }}
        onCancel={() => {
          setIsRetailPreferencesSettingVisible(false)
        }}
      />

      <Modal
        title='温馨提示'
        visible={tipsVisible}
        width={500}
        keyboard={false}
        maskClosable={false}
        closable={false}
        style={{ position: 'relative' }}
        onOk={() => {
          setIsTipsVisible(false)
        }}
        onCancel={() => {
          setIsTipsVisible(false)
        }}
      >
        <div style={{ height: '60px', lineHeight: '60px' }}>
          监管要求:电子病历需要上传医生数据,未选择医生会存在违规风险
        </div>
        <Checkbox
          style={{ position: 'absolute', bottom: '15px' }}
          onChange={({ target }) => {
            const { checked } = target
            const flag = checked ? '1' : '0'
            localStorage.setItem('SHOWJGMODAL', flag)
          }}
        >
          不再提示
        </Checkbox>
      </Modal>

      <Modal
        cancelText='返回'
        okButtonProps={{
          style: { display: 'none' },
        }}
        visible={sumVisible}
        title={`${patientInsurance?.name} ${sumList?.insutype} 账户年度累计`}
        onCancel={() => setSumVisible(false)}
      >
        <div style={{ marginTop: '-10px' }}>
          <span style={{ fontWeight: 'bold' }}>
            当年账户余额：{patientInsurance?.dnzhye}
          </span>
          <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>
            历年账户余额：{patientInsurance?.lnzhye}
          </span>
        </div>
        <div>
          <span style={{ fontWeight: 'bold' }}>
            工作单位：{patientInsurance?.brdw}
          </span>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold' }}>
            人员类型：{patientInsurance?.memberTypemc}
          </span>
        </div>
        <div></div>
        <Table
          dataSource={sumList?.currYearInsCum}
          columns={[
            {
              title: '累计类型名称',
              align: 'left',
              render: (_, r) => {
                return r.name
              },
            },
            {
              title: '累计数',
              align: 'center',
              render: (_, r) => {
                return r.cum
              },
            },
          ]}
          pagination={false}
        />
      </Modal>
      <DiagnosisAndPrescriptionModal
        treatmentId={
          recipes.length > 0
            ? recipes[0].treatmentId
            : currenttreatmentId
            ? currenttreatmentId.toString()
            : undefined
        }
        time={recipes.length > 0
          ? recipes[0].recipeTime
          : undefined}
        visible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false)
          handleFullReset()
        }}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      ></DiagnosisAndPrescriptionModal>
      {/* 药品超出挂网价提醒 */}
      <OverOnlineLimitModal
        visible={isOverOnlineModalVisible}
        list={overOnlineLimitList}
        onContinue={handleOverOnlineContinue}
        onCancel={() => setIsOverOnlineModalVisible(false)}
      />
      <Modal
        title='温馨提醒'
        visible={isTipsModalVisible}
        width={700}
        footer={null}
        maskClosable={false}
        closable
        onOk={() => {
          setIsTipsModalVisible(false)
          form.resetFields(['disease'])
          setInputValues({})
          setInputIcds({})
        }}
        onCancel={() => {
          setIsTipsModalVisible(false)
          form.resetFields(['disease'])
          setInputValues({})
          setInputIcds({})
        }}
      >
        <Text>
          <div>该患者存在备案的特慢病信息，请搜索一个明确诊断，然后点击引用</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {searchMedicalList?.map((v: any) => {
              const disease = {
                icds: v.diseaseCode,
                id: v.id,
                name: v.diseaseName,
              }
              return (
                <div
                  style={{
                    display: 'flex',
                    marginTop: '10px',
                    alignItems: 'center',
                  }}
                  key={v.icds}
                >
                  <span
                    style={{
                      width: '220px',
                      color: '#027AFF',
                      padding: '0 10px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginRight: '10px',
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                    key={v.icds}
                  >
                    {`${disease.name}/${disease.icds}`}
                  </span>
                  <div style={{ height: '30px' }}>
                    <Form form={form}>
                      <Form.Item name={`diagnosis-${disease.icds}`} label=''>
                        <Select
                          style={{ width: '330px' }}
                          showSearch
                          onClick={() => {
                            getDiseaseList(
                              disease.icds,
                              inputValues[disease.icds]
                            )
                          }}
                          onChange={(e) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          }}
                          onSearch={(e: any) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          }}
                          onSelect={(v: any) => {
                            const name = v?.split('/')?.[0]
                            const icds = v?.split('/')?.[1]
                            handleOptionSelect(disease.icds, name, icds)
                          }}
                          filterOption={false}
                          optionFilterProp='children'
                          allowClear
                        >
                          {diseaseOptions?.[disease.icds]?.map((v: any) => {
                            return (
                              <Option value={v.diseaseName} key={v.diseaseName}>
                                {v.disName}/{v.icds}
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Form>
                  </div>
                  <Button
                    type='primary'
                    size='small'
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      const data: any = {
                        icds: inputIcds[disease.icds],
                        name: inputValues[disease.icds],
                        id: disease.id,
                      }
                      if (disable) {
                        setIsTipsModalVisible(false)
                        form.resetFields(['disease'])
                        setInputValues({})
                        setInputIcds({})
                      } else {
                        if(!inputValues[disease.icds]){
                          notification.info({
                            message:'请搜索一个明确诊断，然后点击引用'
                          })
                          return 
                        }
                      if (
                        !selectedDiseases?.find((d) => d?.icds == inputIcds[disease?.icds])
                      ) {
                        diseasesChose(v)
                        setSelectedDiseases(selectedDiseases.concat(data))
                        const obj = {
                          ...localObj,
                          disease: selectedDiseasesZIFEI
                            .concat(data)
                            .map((v: any) => `${v.name}/${v.icds}`)
                            .join(','),
                          selectedDiseasesZIFEI: selectedDiseasesZIFEI.concat(
                            data
                          ),
                        }
                        setLocalObj(obj)
                        setPatientObj({
                          ...patientObj,
                          ...obj,
                        })
                        localStorage.setItem('localObj', JSON.stringify(obj))
                        form.resetFields(['disease'])
                       }
                       setIsTipsModalVisible(false)
                       form.resetFields(['disease'])
                       setInputValues({})
                       setInputIcds({})
                      }
                    }}
                  >
                    引用
                  </Button>
                </div>
              )
            })}
          </div>
        </Text>
        <Row justify='end' style={{ marginTop: '20px' }}>
          <Button
            onClick={() => {
              setIsTipsModalVisible(false)
              form.resetFields()
              setInputIcds({})
              setInputValues({})
            }}
            style={{ marginRight: '10px' }}
          >
            不引用
          </Button>
          <Button
            type='primary'
            onClick={() => {
              const data = searchMedicalList?.map((v: any) => {
                return {
                  icds: inputIcds[v.diseaseCode],
                  id: v.id,
                  name: inputValues[v.diseaseCode],
                }
              })
              if (disable) {
                return
              } else {
                const DiseaseList = mergeUniqueArrays(selectedDiseases, data)
                setSelectedDiseases(DiseaseList?.filter((v: any) => v?.name))
                diseasesChose(searchMedicalList?.[data?.length - 1])
                const obj = {
                  ...localObj,
                  disease: DiseaseList?.filter((v: any) => v?.name)
                    .map((v: any) => `${v.name}/${v.icds}`)
                    .join(','),
                  selectedDiseasesZIFEI: DiseaseList?.filter(
                    (v: any) => v?.name
                  ),
                }
                setLocalObj(obj)
                setPatientObj({
                  ...patientObj,
                  ...obj,
                })
                localStorage.setItem('localObj', JSON.stringify(obj))
              }
              setIsTipsModalVisible(false)
              form.resetFields(['disease'])
              setInputValues({})
              setInputIcds({})
            }}
          >
            全部引用
          </Button>
        </Row>
      </Modal>
      <MedicationAdministrationRecordModal
        insuranceBean={insuranceItem}
        patientId={parintInfo?.patientId}
        patientInsurance={patientInsurance}
        doctorId={form.getFieldValue('registrationDoctorId')}
        visible={isMedicationAdministrationRecordVisible}
        registration={patientInsurance}
        onOK={() => {
          setIsMedicationAdministrationRecordVisible(false)
        }}
        onCancel={() => {
          setIsMedicationAdministrationRecordVisible(false)
        }}
      />
      <YBJRJSModal
        patientId={parintInfo?.patientId}
        name={parintInfo?.name}
        visible={isYBJRJSModalVisible}
        onCancel={() => {
          setIsYBJRJSModalVisible(false)
        }}
        onOk={() => {
          setIsYBJRJSModalVisible(false)
        }}
      />
      <Modal
        width={800}
        footer={!isAutoRemind ? null : (
          <div>
            <Button onClick={() => {
              setIsAutoRemind(false)
              setIsShowBeforeAlert(false)
            }}>取消</Button>
            <Button type='primary' onClick={() => {
              setIsAutoRemind(false)
              setIsShowBeforeAlert(false)
              gotoPayment()
            }}>继续结算</Button>
          </div>
        )}
        title='医保事前审核'
        visible={isShowBeforeAlert}
        onOk={(v) => {
          setIsAutoRemind(false)
          setIsShowBeforeAlert(false)
        }}
        onCancel={(v) => {
          setIsAutoRemind(false)
          setIsShowBeforeAlert(false)
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: beforeAlertMessage }} />
      </Modal>
    </Col>
  )
}
